/* 韦氏所有请求文件 */
import {wUrl} from '../api/url.js'
import {urlAssets} from '../api/url.js'
import axios from 'axios'
export default{
  install (Vue) {
    let addrPre = wUrl.host + wUrl.port + wUrl.path
    let addrPre_openpl = wUrl.host + wUrl.port_openpl + wUrl.path_openpl
    Vue.prototype.$addrPre = addrPre // 通用接口前缀
    let appUrlPre = wUrl.host + wUrl.port_app+wUrl.path // 应用块的前缀
    Vue.prototype.$appUrlTag = 1 // 应用接口版本，最初版为0 （0，1）
    Vue.prototype.$host = wUrl.host + wUrl.port

    //prefix: apkUrl: fileUrl: picUrl: webUrl: terUrl:
    Vue.prototype.$imgUploadUrl = addrPre + '/upload/upload.do'
    Vue.prototype.$fileUploadUrl = addrPre + '/appFile/fileupload.do'
    Vue.prototype.$launchUlUrl = addrPre + '/launcher/fileupload.do'
    Vue.prototype.$fileUpImgloadUrl = addrPre + '/file/fileupload.do'
    Vue.prototype.$filePbCerUploadUrl = addrPre + '/sgn/fileupload.do'
    Vue.prototype.$fileExcelUlUrl = addrPre + '/import/terminalList.do'
    Vue.prototype.$urls = urlAssets
    Vue.prototype.$videoUrl = addrPre + '/video/fileupload.do'
    Vue.prototype.$adUlUrl = wUrl.bannerFileUrl + '/bannerFile/upload.do'
    Vue.prototype.$mcTempUrl = addrPre + '/model/merchants.xlsx'
    Vue.prototype.$mcUploadUrl = addrPre + '/mechanism/import.do' 
    Vue.prototype.$push_device_Url = addrPre + '/kmc/importTers.do' 

	// 设备激活删除设备
		Vue.prototype.$delTerAct = (ids, callback, error) => {
		  var path = '/terminalActivate/delete.do'
		  var url = addrPre + path
		  var param = {ids: ids}
		  jsonRqes(url, param, callback, error)
		}
    	// 设备激活批量添加设备
		Vue.prototype.$pushActivate = (data, callback, error) => {
		  var path = '/terminalActivate/activate.do'
		  var url = addrPre + path
		  var data = data
		
		  jsonRqes(url, data, callback, error)
		}
      // 激活记录列表
    Vue.prototype.$terminalActivate = (page, rows, terminalNo, mechId, callback, error) => {
      var path = '/terminalActivate/list.do'
      var url = addrPre + path
      var param = {page: page, rows: rows, terminalNo: terminalNo, mechId: mechId}
      jsonRqes(url, param, callback, error)
    }
      //批量推送设备 new 2025/7/9
    Vue.prototype.$terActImport= (fileNo, callback, error) => {
      var path = '/terminalActivate/activateByImport.do'
      var url = addrPre + path
      var param = { fileNo: fileNo}
      jsonRqes(url, param, callback, error)
    }
     //批量推送设备 new 2025/7/9
    Vue.prototype.$pspUninstImport = (appId, fileNo, fileType, callback, error) => {
      var path = '/pspUninstallApp/pushByImport.do'
      var url = addrPre + path
      var param = {appId: appId, fileNo: fileNo, fileType: fileType}
      jsonRqes(url, param, callback, error)
    }
    //批量推送设备 new 2025/7/9
    Vue.prototype.$pushByImport = (appId, fileNo, fileType, callback, error) => {
      var path = '/pspChangeApp/pushByImport.do'
      var url = addrPre + path
      var param = {appId: appId, fileNo: fileNo, fileType: fileType}
      jsonRqes(url, param, callback, error)
    }
    // mfa解绑
    Vue.prototype.$mfaUnbind = (userId, code, callback, error) => {
      var path = '/user/unbindMfa.do'
      var url = addrPre + path
      var param = {userId: userId, code: code}
      jsonRqes(url, param, callback, error)
    }

    // mfa完成绑定
    Vue.prototype.$mfaBind = (userId, code, callback, error) => {
      var path = '/user/bindMfa.do'
      var url = addrPre + path
      var param = {userId: userId, code: code}
      jsonRqes(url, param, callback, error)
    }

    // mfa绑定二维码
    Vue.prototype.$mfaQrcode = (userId, callback, error) => {
      var path = '/user/getQRCode.do'
      var url = addrPre + path
      var param = {userId: userId}
      jsonRqes(url, param, callback, error)
    }

    // mfa身份验证
    Vue.prototype.$mfaIdCheck = (userId, password, callback, error) => {
      var path = '/user/authentication.do'
      var url = addrPre + path
      var param = {userId: userId, password: password}
      jsonRqes(url, param, callback, error)
    }

    // 登录动态码验证
    Vue.prototype.$loginCodeCheck = (userId, code, callback, error) => {
      var path = '/user/checkCode.do'
      var url = addrPre + path
      var param = {userId: userId, code: code}
      jsonRqes(url, param, callback, error)
    }

    // 锁屏/解屏
    Vue.prototype.$loaunScreen = (terminalNo, lockScreenPwd, waitTime, status, callback, error) => {
      var path = '/cmd/lockScreen.do'
      var url = addrPre + path
      var param = {waitTime: waitTime, status: status, terminalNo: terminalNo, lockScreenPwd: lockScreenPwd}
      jsonRqes(url, param, callback, error)
    }

    // 激活认证
    Vue.prototype.$authLogin = (userName, password, code, callback, error) => {
      var path = '/user/auth.do'
      var url = addrPre + path
      var param = {userName: userName, password: password, code: code}
      jsonRqes(url, param, callback, error)
    }

    // 设置app自启动
    Vue.prototype.$autoLaunchApp = (terminalNo, packageName, callback, error) => {
      var path = '/cmd/startingApp.do'
      var url = addrPre + path
      var param = {terminalNo: terminalNo, packageName: packageName}
      jsonRqes(url, param, callback, error)
    }

    // 获取截屏列表
    Vue.prototype.getSCapture = (page, rows, terminalNo, mechId, callback, error) => {
      var path = '/screencap/list.do'
      var url = addrPre + path
      var param = {page: page, rows: rows, terminalNo: terminalNo, mechId: mechId}
      jsonRqes(url, param, callback, error)
    }

    // 截屏
    Vue.prototype.sCapture = (terminalNo, callback, error) => {
      var path = '/screencap/getTerScreenCAP.do'
      var url = addrPre + path
      var param = {terminalNo: terminalNo}
      jsonRqes(url, param, callback, error)
    }

    // 交易列表
    Vue.prototype.$translist = (page, rows, terminalNo, mechId, mcID, termID, type, trId, callback, error) => {
      var path = '/trading/list.do'
      var url = addrPre + path
      var param = {page: page, rows: rows, terminalNo: terminalNo, mechId: mechId, mcID: mcID, termID: termID, type: type, trId: trId}
      jsonRqes(url, param, callback, error)
    }

    // 删除截屏
    Vue.prototype.$delsCapture = (ids, callback, error) => {
      var path = '/screencap/delete.do'
      var url = addrPre + path
      var param = {ids: ids}
      jsonRqes(url, param, callback, error)
    }

    Vue.prototype.$delTerLog = (ids, callback, error) => {
      var path = '/terminalLog/delete.do'
      var url = addrPre + path
      var param = {ids: ids}
      jsonRqes(url, param, callback, error)
    }

    // 获取日志
    Vue.prototype.$getTerLog = (code, page, rows, terminalNo, mechId, beginTime, endTime, callback, error) => {
      var path = '/terminalLog/getTerLogList.do'
      var url = addrPre + path
      var param = {code: code, page: page, rows: rows, terminalNo: terminalNo, mechId: mechId, beginTime: beginTime, endTime: endTime}

      jsonRqes(url, param, callback, error)
    }

    // 删除日志
    Vue.prototype.$delTerLog = (ids, callback, error) => {
      var path = '/terminalLog/delete.do'
      var url = addrPre + path
      var param = {ids: ids}
      jsonRqes(url, param, callback, error)
    }

    // 日志下发指令
    Vue.prototype.$operateTerLog = (type, logId, terminalNo, callback, error) => {
      var path = '/terminalLog/getLogs.do'
      var url = addrPre + path
      var param = {terminalNo: terminalNo, logId: logId, type: type}
      jsonRqes(url, param, callback, error)
    }

    // 导出设备到excel
    Vue.prototype.$outputEq2Excel = (terminalId, areaid, orderType, time_orderType, terminalName, terminal_status,beginTime,endTime) => {
      var token = localStorage.user ? localStorage.user : ''
      var url = addrPre + `/export/terminal_info.do?terminalId=${terminalId}&language=`+localStorage.system_lang + `&areaid=${areaid}&orderType=${orderType}&time_orderType=${time_orderType}&terminalName=${terminalName}&terminal_status=${terminal_status}&beginTime=${beginTime}&endTime=${endTime}&token=${token}`
      // alert(url)
      window.open(url, '_blank')
    }
		
	// 批量导出设备
	Vue.prototype.$outputDevice = (terminalNo, status, mechId) => {
	  var token = localStorage.user ? localStorage.user : ''
	  var url = addrPre + `/kmc/export.do?terminalNo=${terminalNo}&language=`+localStorage.system_lang + `&status=${status}&mechId=${mechId}&token=${token}`
	  // alert(url)
	  window.open(url, '_blank')
	}

    // 获取验证码
    Vue.prototype.$getCheckcode = (callback, error) => {
      var path = '/user/getCode.do'
      var url = addrPre + path
      var param = {}
      getRqs(url, param, callback, error)
    }

    // 获取公钥
    Vue.prototype.$getPublicKey = (callback, error) => {
      var path = '/user/getPublicKey.do'
      var url = addrPre + path
      var param = {}
      getRqs(url, param, callback, error)
    }

    // 检查公告版本信息
    Vue.prototype.$checkVBInfo = (callback, error) => {
      var path = '/notice/getNoticeInfo.do'
      var url = addrPre + path
      var param = {}
      jsonRqes(url, param, callback, error)
    }
    // 公告列表
    Vue.prototype.$bulletin = (page, rows, noticeName, callback, error) => {
      var path = '/notice/list.do'
      var url = addrPre + path
      var param = {noticeName: noticeName, page: page, rows: rows}
      jsonRqes(url, param, callback, error)
    }
    // 添加公告
    Vue.prototype.$addBulletin = (noticeName, noticeInfo, callback, error) => {
      var path = '/notice/add.do'
      var url = addrPre + path
      var param = {noticeName: noticeName, noticeInfo: noticeInfo}
      jsonRqes(url, param, callback, error)
    }
    // 公告详情
    Vue.prototype.$bulletinDetail = (id, callback, error) => {
      var path = '/notice/detail.do'
      var url = addrPre + path
      var param = {id: id}
      jsonRqes(url, param, callback, error)
    }
    // 编辑公告
    Vue.prototype.$editBulletin = (id, noticeName, noticeInfo, callback, error) => {
      var path = '/notice/edit.do'
      var url = addrPre + path
      var param = {id: id, noticeName: noticeName, noticeInfo: noticeInfo}
      jsonRqes(url, param, callback, error)
    }
    // 删除公告
    Vue.prototype.$delBulletin = (ids, callback, error) => {
      var path = '/notice/delete.do'
      var url = addrPre + path
      var param = {ids: ids}
      jsonRqes(url, param, callback, error)
    }

    // 版本更新列表
    Vue.prototype.$udVerList = (page, rows, callback, error) => {
      var path = '/versionManage/list.do'
      var url = addrPre + path
      var param = {page: page, rows: rows}
      jsonRqes(url, param, callback, error)
    }
    // 添加版本更新
    Vue.prototype.$addUdVer = (version, date, desc, callback, error) => {
      var path = '/versionManage/add.do'
      var url = addrPre + path
      var param = {version: version, date: date, desc: desc}
      jsonRqes(url, param, callback, error)
    }
    // 编辑版本更新
    Vue.prototype.$editUdVer = (id, version, date, desc, callback, error) => {
      var path = '/versionManage/edit.do'
      var url = addrPre + path
      var param = {id: id, version: version, date: date, desc: desc}
      jsonRqes(url, param, callback, error)
    }
    // 版本更新详情
    Vue.prototype.$udVerDetail = (id, callback, error) => {
      var path = '/versionManage/detail.do'
      var url = addrPre + path
      var param = {id: id}
      jsonRqes(url, param, callback, error)
    }
    // 删除版本更新
    Vue.prototype.$delUdVer = (ids, callback, error) => {
      var path = '/versionManage/delete.do'
      var url = addrPre + path
      var param = {ids: ids}
      jsonRqes(url, param, callback, error)
    }

    // 设备指令
    Vue.prototype.$dvcmd = (zl, type, packageName, terminalNo, callback, error) => {
      var path = '/terminal/cmd.do'
      var url = addrPre + path
      var param = {zl: zl, type: type, packageName: packageName, terminalNo: terminalNo}
      jsonRqes(url, param, callback, error)
    }

    // 生成开发者密钥
    Vue.prototype.$generateKey = (userId, callback, error) => {
      var path = '/user/resetAppKey.do'
      var url = addrPre + path
      var param = {userId: userId}
      jsonRqes(url, param, callback, error)
    }

    // 通道列表
    Vue.prototype.$passageList = (page, rows, appName, isauthen, merchantid, callback, error) => {
      var path = '/channel/listChannel.do'
      var url = addrPre_openpl + path
      var param = {page: page, rows: rows, appName: appName, isAuthen: isauthen, merchantId: merchantid}
      jsonRqes(url, param, callback, error)
    }

    // 删除通道
    Vue.prototype.$delPassage = (appId, callback, error) => {
      var path = '/channel/deleteChannel.do'
      var url = addrPre_openpl + path
      var param = {appId: appId}
      jsonRqes(url, param, callback, error)
    }

    // 通道详情
    Vue.prototype.$passageDetail = (appId, callback, error) => {
      var path = '/channel/detailChannel.do'
      var url = addrPre_openpl + path
      var param = {appId: appId}
      jsonRqes(url, param, callback, error)
    }

    // 编辑通道
    Vue.prototype.$editPassage = (param, callback, error) => {
      var path = '/channel/editChannel.do'
      var url = addrPre_openpl + path
      var param = param
      jsonRqes(url, param, callback, error)
    }

    // 添加通道
    Vue.prototype.$addPassage = (param, callback, error) => {
      var path = '/channel/addChannel.do'
      var url = addrPre_openpl + path
      var param = param
      jsonRqes(url, param, callback, error)
    }

    // 首页系统固件统计
    Vue.prototype.$indexSysFmCount = (mechId, type, callback, error) => {
      var path = '/statistics/terminalInfoCount.do'
      var url = addrPre + path
      var param = {mechId: mechId, type: type}
      jsonRqes(url, param, callback, error)
    }

    // 首页bar统计
    Vue.prototype.$indexDvStCount = (mechId, type, beginDate, endDate, callback, error) => {
      var path = '/statistics/onlineStatusCount.do'
      var url = addrPre + path
      var param = {mechId: mechId, type: type, beginDate: beginDate, endDate: endDate}
      jsonRqes(url, param, callback, error)
    }

    // 密码键盘列表
    Vue.prototype.$keyblist = (page, rows, distributorId, terminalNo, callback, error) => {
      var path = '/terminalKey/getKeyBoard.do'
      var url = addrPre + path
      var param = {page: page, rows: rows, distributorId: distributorId, terminalNo: terminalNo}
      jsonRqes(url, param, callback, error)
    }

    // 系统推送任务列表
    Vue.prototype.$pTaskList = (page, rows, taskType, taskName, orderName, orderType, terminalNo, callback, error) => {
      var path = '/task_manage/task_list.do'
      var url = addrPre + path
      var param = {orderName: orderName, orderType: orderType, page: page, rows: rows, taskType: taskType, taskName: taskName, terminalNo: terminalNo}
      jsonRqes(url, param, callback, error)
    }

    // 系统推送任务导出任务
    Vue.prototype.$pTaskExport = (taskId,terminalName,orderType,status) => {
      var path = '/export/new_task.do'
      var url = addrPre + path + '?taskId=' + taskId + '&terminalName='+ terminalName + '&orderType='+ orderType + '&status='+ status + '&language='+ localStorage.system_lang
      return url
      // var param = {page: page, rows: rows, pushType: pushType, taskName: taskName}
      // jsonRqes(url, param, callback, error)
    }

    // 系统推送文件列表
    Vue.prototype.$pTaskPushList = (page, rows, name, mechId, fileType, fileId, callback, error) => {
      var path = '/fileManage/file_list.do'
      var url = addrPre + path
      var param = {page: page, rows: rows, fileName: name, mechId: mechId, fileType: fileType, fileId: fileId}
      jsonRqes(url, param, callback, error)
    }

    // 系统推送添加任务
    Vue.prototype.$pTaskAddTask = (taskName, subTask, callback, error) => {
      var path = '/task_manage/add_task.do'
      var url = addrPre + path
      var param = {taskName: taskName, subTask: subTask}
      jsonRqes(url, param, callback, error)
    }

    // 系统推送编辑任务
    Vue.prototype.$pTaskEditTask = (taskId, taskName, subTask, callback, error) => {
      var path = '/task_manage/edit_task.do'
      var url = addrPre + path
      var param = {taskId: taskId, taskName: taskName, subTask: subTask}
      jsonRqes(url, param, callback, error)
    }


    // 系统推送进度
    Vue.prototype.$pTaskProgress = (taskId, callback, error) => {
      var path = '/task_manage/push_detail.do'
      var url = addrPre + path
      var param = {taskId: taskId}
      jsonRqes(url, param, callback, error)
    }

    // 系统推送编辑
    Vue.prototype.$pTaskEdit = (taskId, callback, error) => {
      var path = '/task_manage/task_detail.do'
      var url = addrPre + path
      var param = {taskId: taskId}
      jsonRqes(url, param, callback, error)
    }

    // 系统推送 状态统计
    Vue.prototype.$pTaskStatistics = (taskId, callback, error) => {
      var path = '/push_manage/status_count.do'
      var url = addrPre + path
      var param = {taskId: taskId}
      jsonRqes(url, param, callback, error)
    }


    // 参数管理绑定全部
    Vue.prototype.$bwlBindAll = (profileId, type, callback, error) => {
      var path = '/profilesManage/updateType.do'
      var url = addrPre + path
      var param = {profileId: profileId, type: type}
      jsonRqes(url, param, callback, error)
    }

    // 参数绑定列表
    Vue.prototype.$bwlBindList = (page, rows, mechId, terminalName, status, id, callback, error) => {
      var path = '/profilesManage/terList.do'
      var url = addrPre + path
      var param = {page: page, rows: rows, mechId: mechId, terminalName: terminalName, status: status, id: id}
      jsonRqes(url, param, callback, error)
    }

    // 参数管理绑定设备
    Vue.prototype.$bwlBind = (terminalIds, id, callback, error) => {
      var path = '/profilesManage/addTers.do'
      var url = addrPre + path
      var param = {terminalIds: terminalIds, id: id}
      jsonRqes(url, param, callback, error)
    }

    // 参数管理设备绑定删除
    Vue.prototype.$bwlUnbind = (ids, callback, error) => {
      var path = '/profilesManage/delTers.do'
      var url = addrPre + path
      var param = {ids: ids}
      jsonRqes(url, param, callback, error)
    }


    // file start
    // 设备配置列表
    Vue.prototype.$getfile = (page, rows, name, mechId, type, subType, status,orderName, orderType, callback, error) => {
      var path = '/fileManage/list.do'
      var url = addrPre + path
      var param = {orderType: orderType, orderName: orderName, page: page, rows: rows, name: name, mechId: mechId, type: type, subType: subType, status: status}
      jsonRqes(url, param, callback, error)
    }

    //添加文件
    Vue.prototype.$addFile = (fileName, fileVersion, hashCode, fileSize, fileUrl, fileType, subFileType, param1, mechId, memo, callback, error) => {
      var path = '/fileManage/add.do'
      var url = addrPre + path
      var param = {fileName: fileName, fileVersion: fileVersion, hashCode: hashCode, fileSize: fileSize, fileUrl: fileUrl, fileType: fileType, subFileType: subFileType, param1: param1, mechId: mechId, memo: memo}
      jsonRqes(url, param, callback, error)
    }

    //编辑文件
    Vue.prototype.$editFile = (fileId, fileName, fileVersion, hashCode, fileSize, fileUrl, fileType, subFileType, param1, mechId, memo, callback, error) => {
      var path = '/fileManage/edit.do'
      var url = addrPre + path
      var param = {fileId: fileId, fileName: fileName, fileVersion: fileVersion, hashCode: hashCode, fileSize: fileSize, fileUrl: fileUrl, fileType: fileType, subFileType: subFileType, param1: param1, mechId: mechId, memo: memo}
      jsonRqes(url, param, callback, error)
    }
    // 删除文件
    Vue.prototype.$delfile = (ids, callback, error) => {
      var path = '/fileManage/delete.do'
      var url = addrPre + path
      var param = {ids: ids}
      jsonRqes(url, param, callback, error)
    }
    // 重推配置失败设备
    Vue.prototype.$repushDSFailDv = (terminalNo, configId, callback, error) => {
      var path = '/terminalConfig/reConfig.do'
      var url = addrPre + path
      var param = {terminalNo: terminalNo, configId: configId}
      jsonRqes(url, param, callback, error)
    }
    // 文件推送测试
    Vue.prototype.$filePushTest = (id, terminalNo, callback, error) => {
      var path = '/fileManage/push_test.do'
      var url = addrPre + path
      var param = {id: id, terminalNo: terminalNo}
      jsonRqes(url, param, callback, error)
    }
    // 失败推送
    Vue.prototype.$failTaskRepush = (taskId, callback, error) => {
      var path = '/task_manage/rePushAll.do'
      var url = addrPre + path
      var param = {taskId: taskId}
      jsonRqes(url, param, callback, error)
    }
    // 追加推送
    Vue.prototype.$appendPush = (taskId, terminalNos, pushType, mechId, terminalName, fileNo, Terminalstatus,snBegin,snEnd, callback, error) => {
      var path = '/task_manage/add_push.do'
      var url = addrPre + path
      var param = {taskId: taskId, terminalNos: terminalNos, pushType: pushType, mechId: mechId, terminalName: terminalName, fileNo: fileNo, Terminalstatus: Terminalstatus,snBegin:snBegin,snEnd:snEnd}
      jsonRqes(url, param, callback, error)
    }
    // 系统配置推送
    Vue.prototype.$sysconfigPush = (configId, terminalNos, pushType, mechId, terminalName, fileNo,snBegin,snEnd, callback, error) => {
      var path = '/sysConfig/push.do'
      var url = addrPre + path
      var param = {configId: configId, terminalNos: terminalNos, pushType: pushType, mechId: mechId, terminalName: terminalName, fileNo: fileNo,snBegin:snBegin,snEnd:snEnd}
      jsonRqes(url, param, callback, error)
    }
    // 文件审核
    Vue.prototype.$verifyFile = (id, content, status, callback, error) => {
      var path = '/fileManage/audit.do'
      var url = addrPre + path
      var param = {id: id, content: content, status: status}
      jsonRqes(url, param, callback, error)
    }

    // 文件推送
    Vue.prototype.$filePush = (fileId, autoOpen, installType, pushType, terminalNos, mechId, terminalStatus, terminalNo, fileNo, callback, error) => {
      var path = '/push_manage/file_push.do'
      var url = addrPre + path
      var param = {fileId: fileId, autoOpen: autoOpen, installType: installType, pushType: pushType, terminalNos: terminalNos, mechId:mechId, terminalStatus: terminalStatus, terminalNo: terminalNo, fileNo: fileNo}
      jsonRqes(url, param, callback, error)
    }

    // file end

    // ajly ftp start
    Vue.prototype.$getFTPDetail = (callback, error) => {
      var path = '/ftpServer/detail.do'
      var url = addrPre + path
      var param = {}
      jsonRqes(url, param, callback, error)
    }
    Vue.prototype.$addFTP = (opeTime, ftpAddress, ftpPort, ftpUser, ftpPwd,ftpPath,updateTime, callback, error) => {
      var path = '/ftpServer/add.do'
      var url = addrPre + path
      var param = {opeTime: opeTime, ftpAddress: ftpAddress, ftpPort: ftpPort, ftpUser: ftpUser, ftpPwd: ftpPwd, ftpPath: ftpPath, updateTime: updateTime}
      jsonRqes(url, param, callback, error)
    }
    Vue.prototype.$editFTP = (id, opeTime, ftpAddress, ftpPort, ftpUser, ftpPwd,ftpPath,updateTime, callback, error) => {
      var path = '/ftpServer/edit.do'
      var url = addrPre + path
      var param = {opeTime: opeTime, id: id, ftpAddress: ftpAddress, ftpPort: ftpPort, ftpUser: ftpUser, ftpPwd: ftpPwd, ftpPath: ftpPath, updateTime: updateTime}
      jsonRqes(url, param, callback, error)
    }
    Vue.prototype.$ftpfList = (callback, error) => {
      var path = '/ftpServer/file_list.do'
      var url = addrPre + path
      var param = {}
      jsonRqes(url, param, callback, error)
    }

    // file end


    // device start
    // 设备配置列表
    Vue.prototype.$getTcList = (page, rows, name, orderName, orderType, callback, error) => {
      var path = '/terminalConfig/list.do'
      var url = addrPre + path
      var param = {orderType: orderType, orderName: orderName, page: page, rows: rows, name: name}
      jsonRqes(url, param, callback, error)
    }

    // 添加设备配置
    Vue.prototype.$addTc = (configName, configDesc, params, callback, error) => {
      var path = '/terminalConfig/add.do'
      var url = addrPre + path
      var param = {configName: configName, configDesc: configDesc, param: params}
      jsonRqes(url, param, callback, error)
    }

    // 编辑设备配置
    Vue.prototype.$editTc = (id, configName, configDesc, params, callback, error) => {
      var path = '/terminalConfig/edit.do'
      var url = addrPre + path
      var param = {id: id, configName: configName, configDesc: configDesc, param: params}
      jsonRqes(url, param, callback, error)
    }

    // 设备配置详情
    Vue.prototype.$tcDetail = (id, callback, error) => {
      var path = '/terminalConfig/detail.do'
      var url = addrPre + path
      var param = {id: id}
      jsonRqes(url, param, callback, error)
    }

    // 删除设备配置
    Vue.prototype.$delTc = (ids, callback, error) => {
      var path = '/terminalConfig/delete.do'
      var url = addrPre + path
      var param = {ids: ids}
      jsonRqes(url, param, callback, error)
    }

    // 设备配置绑定设备
    Vue.prototype.$tcBindDevice = (terminalIds, configId, callback, error) => {
      var path = '/terminalConfig/addTers.do'
      var url = addrPre + path
      var param = {terminalIds: terminalIds, configId: configId}
      jsonRqes(url, param, callback, error)
    }


    // 设备配置 绑定设备列表
    Vue.prototype.$tcDeviceBindList = (page, rows, mechId, terminalName, status, configId, orderName, orderType, callback, error) => {
      var path = '/terminalConfig/terList.do'
      var url = addrPre + path
      var param = {orderType: orderType, orderName: orderName, page: page, rows: rows, mechId: mechId, terminalName: terminalName, status: status, configId: configId}
      jsonRqes(url, param, callback, error)
    }

    // 设备配置 删除绑定设备
    Vue.prototype.$tcDelDevice = (ids, callback, error) => {
      var path = '/terminalConfig/deleteTers.do'
      var url = addrPre + path
      var param = {ids: ids}
      jsonRqes(url, param, callback, error)
    }
		
		
	// 设备列表 批量迁移
	Vue.prototype.$moveByImport = (param,callback, error) => {
	  var path = '/terminal/moveByImport.do'
	  var url = addrPre + path
	  var param = param
	  getRqs(url, param, callback, error)
	}
	
	//  推送设备
	Vue.prototype.$device_push = (data, callback, error) => {
	  var path = '/kmc/add.do'
	  var url = addrPre + path
	  var param =  data
	  jsonRqes(url, param, callback, error)
	}

    /* device end */


    // key start
    // 密钥列表
    Vue.prototype.$getKeyList = (page, rows, name, callback, error) => {
      var path = '/terminalKey/list.do'
      var url = addrPre + path
      var param = {page: page, rows: rows, name: name}
      jsonRqes(url, param, callback, error)
    }

    // 添加密钥
    Vue.prototype.$addKey = (keyName, memo, updateTime, callback, error) => {
      var path = '/terminalKey/add.do'
      var url = addrPre + path
      var param = {keyName: keyName, memo: memo, updateTime: updateTime}
      jsonRqes(url, param, callback, error)
    }

    // 编辑密钥
    Vue.prototype.$editKey = (id, keyName, memo, updateTime, callback, error) => {
      var path = '/terminalKey/edit.do'
      var url = addrPre + path
      var param = {id: id, keyName: keyName, memo: memo, updateTime: updateTime}
      jsonRqes(url, param, callback, error)
    }

    // 密钥详情
    Vue.prototype.$keyDetail = (id, callback, error) => {
      var path = '/terminalKey/detail.do'
      var url = addrPre + path
      var param = {id: id}
      jsonRqes(url, param, callback, error)
    }

    // 删除密钥
    Vue.prototype.$delKey = (ids, callback, error) => {
      var path = '/terminalKey/delete.do'
      var url = addrPre + path
      var param = {ids: ids}
      jsonRqes(url, param, callback, error)
    }

    // 密钥添加设备
    Vue.prototype.$keyAddDevice = (terminalIds, configId, callback, error) => {
      var path = '/terminalKey/addTers.do'
      var url = addrPre + path
      var param = {terminalIds: terminalIds, configId: configId}
      jsonRqes(url, param, callback, error)
    }


    // 密钥绑定设备列表
    Vue.prototype.$keyDeviceBindList = (page, rows, mechId, terminalName, status, configId, callback, error) => {
      var path = '/terminalKey/terList.do'
      var url = addrPre + path
      var param = {page: page, rows: rows, mechId: mechId, terminalName: terminalName, status: status, configId: configId}
      jsonRqes(url, param, callback, error)
    }

    // 密钥删除绑定设备
    Vue.prototype.$keyDelDevice = (ids, callback, error) => {
      var path = '/terminalKey/deleteTers.do'
      var url = addrPre + path
      var param = {ids: ids}
      jsonRqes(url, param, callback, error)
    }

    /* key end */

    // 非智能app/src列表
    Vue.prototype.$getasList = (page, rows, status, mechanismId, type, name, callback, error) => {
      var path = '/resourceManage/list.do'
      var url = addrPre + path
      var param = {status: status, mechanismId: mechanismId, type: type, page: page, rows: rows, name: name}
      jsonRqes(url, param, callback, error)
    }

    // 非智能设备审核/提交审核
    Vue.prototype.$assubmit = (id, content, status, callback, error) => {
      var path = '/resourceManage/audit.do'
      var url = addrPre + path
      var param = {status: status, id: id, content: content}
      jsonRqes(url, param, callback, error)
    }

    // 非智能设备推送
    Vue.prototype.$asTestPush = (id, terminalNo, callback, error) => {
      var path = '/resourceManage/push.do'
      var url = addrPre + path
      var param = {id: id, terminalNo: terminalNo}
      jsonRqes(url, param, callback, error)
    }

    // 添加非智能app/src
    Vue.prototype.$addNonAs = (name, version, md5, size, surl, categoryId, mechanismId, memo, type, callback, error) => {
      var path = '/resourceManage/add.do'
      var url = addrPre + path
      var param = {type: type, memo: memo, name: name, version: version, md5: md5, size: size, url: surl, categoryId: categoryId, mechanismId: mechanismId}
      jsonRqes(url, param, callback, error)
    }

    // 编辑非智能app/src
    Vue.prototype.$editNonAs = (id, status, name, version, md5, size, surl, categoryId, mechanismId, memo, type, callback, error) => {
      var path = '/resourceManage/edit.do'
      var url = addrPre + path
      var param = {id: id, status: status, type: type, memo: memo, name: name, version: version, md5: md5, size: size, url: surl, categoryId: categoryId, mechanismId: mechanismId}
      jsonRqes(url, param, callback, error)
    }

    // 删除非智能app/src
    Vue.prototype.$delNonieAs = (ids, callback, error) => {
      var path = '/resourceManage/delete.do'
      var url = addrPre + path
      var param = {ids: ids}
      jsonRqes(url, param, callback, error)
    }

    // 查询非智能设备
    Vue.prototype.$getNonItDv = (page, rows, mechanismId, terminalNo, terminalStatus,activeStatus,orderName, orderType,snBegin,snEnd, callback, error) => {
      var path = '/scanner/list.do'
      var url = addrPre + path
      var param = {orderName: orderName, orderType: orderType, mechanismId: mechanismId, page: page, rows: rows, terminalNo: terminalNo, terminalStatus: terminalStatus,activeStatus:activeStatus, snBegin: snBegin,snEnd:snEnd}
      jsonRqes(url, param, callback, error)
    }

    // 添加非智能设备
    Vue.prototype.$addNonDv = (terminalNo, terminalName, manufId, mechanismId, address, terminalType, terminalModel, memo, callback, error) => {
      var path = '/scanner/add.do'
      var url = addrPre + path
      var param = {memo: memo, terminalModel: terminalModel, terminalType: terminalType, manufId: manufId, mechanismId: mechanismId, terminalName: terminalName, terminalNo: terminalNo, address: address}
      jsonRqes(url, param, callback, error)
    }

    // 编辑非智能设备
    Vue.prototype.$editNonDv = (id, terminalNo, terminalName, manufId, mechanismId, address, terminalType, terminalModel, memo, callback, error) => {
      var path = '/scanner/edit.do'
      var url = addrPre + path
      var param = {id: id, memo: memo, terminalModel: terminalModel, terminalType: terminalType, manufId: manufId, mechanismId: mechanismId, terminalName: terminalName, terminalNo: terminalNo, address: address}
      jsonRqes(url, param, callback, error)
    }

    // 删除非智能设备
    Vue.prototype.$delNonieDv = (ids, callback, error) => {
      var path = '/scanner/delete.do'
      var url = addrPre + path
      var param = {ids: ids}
      jsonRqes(url, param, callback, error)
    }

    // 非智能设备详情
    Vue.prototype.$noniteqDetail = (id, callback, error) => {
      var path = '/scanner/detail.do'
      var url = addrPre + path
      var param = {id: id}
      jsonRqes(url, param, callback, error)
    }


    // 查询预警信息
    Vue.prototype.$getWarnList = (page, rows, lockStatus, distributorId, terminalNo, event_type, orderName, orderType, callback, error) => {
      var path = '/risk/listBywarning.do'
      var url = addrPre + path
      var param = {orderType: orderType, orderName: orderName, lockStatus: lockStatus, page: page, rows: rows, distributorId: distributorId, terminalNo: terminalNo, event_type: event_type}
      jsonRqes(url, param, callback, error)
    }

    // 查询预警详情
    Vue.prototype.$getWarnDetail = (id, callback, error) => {
      var path = '/risk/getWarning.do'
      var url = addrPre + path
      var param = {id: id}
      jsonRqes(url, param, callback, error)
    }

    // 解锁预警
    Vue.prototype.$killwarn = (id, callback, error) => {
      var path = '/risk/operation.do'
      var url = addrPre + path
      var param = {id: id}
      jsonRqes(url, param, callback, error)
    }

    // 解锁锁定设备
    Vue.prototype.$unlockDevice = (terminalNo, callback, error) => {
      var path = '/risk/unlock.do'
      var url = addrPre + path
      var param = {terminalNo: terminalNo}
      jsonRqes(url, param, callback, error)
    }

    // 锁定设备
    Vue.prototype.$lockDevice = (terminalNo, callback, error) => {
      var path = '/risk/locking.do'
      var url = addrPre + path
      var param = {terminalNo: terminalNo}
      jsonRqes(url, param, callback, error)
    }

    // 解绑围栏
    Vue.prototype.$setFenceBind = (riskId, terminalId, status, callback, error) => {
      var path = '/risk/bindingTerminal.do'
      var url = addrPre + path
      var param = {riskId: riskId, terminalId: terminalId, status: status}
      jsonRqes(url, param, callback, error)
    }


    // 编辑菜单配置
    Vue.prototype.$editConfigMenu = (obj, callback, error) => {
      var path = '/menu/editMenu.do'
      var url = addrPre + path
      var param = {"menuId": obj.menuId,"menuName": obj.name,"url": obj.url,"menuIcon": obj.icon}
      jsonRqes(url, param, callback, error)
    }

    // 设备历史轨迹
    Vue.prototype.$terHisPath = (terminalNo, callback, error) => {
      var path = '/terminal/getTerminalTrack.do'
      var url = addrPre + path
      var param = {terminalNo: terminalNo}
      jsonRqes(url, param, callback, error)
    }

    // 编辑菜单位置
    Vue.prototype.$editMenuPosition = (subId, sortNo, callback, error) => {
      var path = '/menu/editSort.do'
      var url = addrPre + path
      var param = {subId: subId, sortNo: sortNo}
      jsonRqes(url, param, callback, error)
    }

    // 分类查询 厂商
    Vue.prototype.$gpFirm = (distributorId, callback, error) => {
      var path = '/manufacturers/category_list.do'
      var url = addrPre + path
      var param = {distributorId: distributorId}
      jsonRqes(url, param, callback, error)
    }

    // 分类查询 设备类型
    Vue.prototype.$gpDvType = (distributorId, callback, error) => {
      var path = '/terminalType/category_list.do'
      var url = addrPre + path
      var param = {distributorId: distributorId}
      jsonRqes(url, param, callback, error)
    }

    // 分类查询 设备型号
    Vue.prototype.$gpDvModel = (distributorId, callback, error) => {
      var path = '/terminalModel/category_list.do'
      var url = addrPre + path
      var param = {distributorId: distributorId}
      jsonRqes(url, param, callback, error)
    }

    // 分类查询 应用类型
    Vue.prototype.$gpAppType = (mechId, callback, error) => {
      var path = '/appType/category_list.do'
      var url = addrPre + path
      var param = {mechId: mechId}
      jsonRqes(url, param, callback, error)
    }

    // 分类查询 广告类型
    Vue.prototype.$gpAdType = (callback, error) => {
      var path = '/adType/category_list.do'
      var url = addrPre + path
      var param = {}
      jsonRqes(url, param, callback, error)
    }

    // 渠道商查三类型
    Vue.prototype.$mechGetTypes = (id, callback, error) => {
      var path = '/mechanism/baseInfo.do'
      var url = addrPre + path
      var param = {id: id}
      jsonRqes(url, param, callback, error)
    }

    // 据渠道商查类型
    Vue.prototype.$acMcFindApptype = (mechId, callback, error) => {
      var path = '/appType/categoryByMech.do'
      var url = addrPre + path
      var param = {mechId: mechId}
      jsonRqes(url, param, callback, error)
    }

    // 设备绑定应用
    Vue.prototype.$terBindApp = (appId, terminalNo, callback, error) => {
      var path = '/task_manage/ter_app_bind.do'
      var url = addrPre + path
      var param = {appId: appId, terminalNo: terminalNo}
      jsonRqes(url, param, callback, error)
    }

    // 设备配置查询
    Vue.prototype.$getDvSetting = (callback, error) => {
      var path = '/sysConfig/getTerminalConfig.do'
      var url = addrPre + path
      var param = {}
      jsonRqes(url, param, callback, error)
    }

    // 保存设备配置
    Vue.prototype.$setDvSetting = (id, value, callback, error) => {
      var path = '/sysConfig/editTerminalConfig.do'
      var url = addrPre + path
      var param = {id: id, value: value}
      jsonRqes(url, param, callback, error)
    }

    // 日志列表
    Vue.prototype.$logList = (page, rows, beginTime, endTime, type, userName, content, orderName, orderType, callback, error) => {
      var path = '/history/list.do'
      var url = addrPre + path
      var param = {orderType: orderType, orderName: orderName, content: content, page: page, rows: rows, beginTime: beginTime, endTime: endTime, type: type, userName: userName}
      jsonRqes(url, param, callback, error)
    }

    //-------------- 推送任务管理
    // 推送失败重推
    Vue.prototype.$pushRepush = (detailId, callback, error) => {
      var path = '/task_manage/rePush.do'
      var url = addrPre + path
      var param = {detailId: detailId}
      jsonRqes(url, param, callback, error)
    }
    // 推送历史
    Vue.prototype.$pushHis = (page, rows, pushType, pushName, callback, error) => {
      var path = '/push_manage/history_task_list.do'
      var url = addrPre + path
      var param = {page: page, rows: rows, pushType: pushType, pushName: pushName}
      jsonRqes(url, param, callback, error)
    }
    // 推送历史详情
    Vue.prototype.$pushHisDetail = (page, rows, fileId, version, terminalName, status, taskType, callback, error) => {
      var path = '/push_manage/history_detail_list.do'
      var url = addrPre + path
      var param = {page: page, rows: rows, fileId: fileId, version: version, terminalName: terminalName, status: status, taskType: taskType}
      jsonRqes(url, param, callback, error)
    }
    // 添加推送
    Vue.prototype.$addPush = (installType, autoOpen, objId, taskType, pushType, terminalNos, mechId, terminalStatus, terminalNo, fileNo, callback, error) => {
      var path = '/push_manage/push.do'
      var url = addrPre + path
      var param = {installType: installType, autoOpen: autoOpen, objId: objId, taskType: taskType, pushType: pushType, terminalNos: terminalNos, mechId: mechId, terminalStatus: terminalStatus, terminalNo: terminalNo, fileNo: fileNo}
      jsonRqes(url, param, callback, error)
    }

    // 添加应用批量推送
    Vue.prototype.$appBatchPush = (appIds, installType, autoOpen, pushType, terminalNos, mechId, terminalStatus, terminalNo, fileNo, callback, error) => {
      var path = '/push_manage/appsPush.do'
      var url = addrPre + path
      var param = {appIds: appIds, installType: installType, autoOpen: autoOpen, pushType: pushType, terminalNos: terminalNos, mechId: mechId, terminalStatus: terminalStatus, terminalNo: terminalNo, fileNo: fileNo}
      jsonRqes(url, param, callback, error)
    }

    // 是否覆盖已推送设备
    Vue.prototype.$isCoverPush = (taskId, pushParam, isCover, callback, error) => {
      var path = '/push_manage/confirm_push.do'
      var url = addrPre + path
      var param = {taskId: taskId, pushParam: pushParam, isCover: isCover}
      jsonRqes(url, param, callback, error)
    }
    // 推送下载控件
    Vue.prototype.$pushDownCtrl = (taskId, id, status, terminalNo, callback, error) => {
      var path = '/push_manage/download_ctrl.do'
      var url = addrPre + path
      var param = {taskId: taskId, id: id, status: status, terminalNo: terminalNo}
      jsonRqes(url, param, callback, error)
    }
    // 推送列表
    Vue.prototype.$pushList = (page, rows, pushType, pushName, callback, error) => {
      var path = '/push_manage/list.do'
      var url = addrPre + path
      var param = {page: page, rows: rows, pushType: pushType, pushName: pushName}
      jsonRqes(url, param, callback, error)
    }
    // 推送文件详情
    Vue.prototype.$pushFileDetail = (taskId, callback, error) => {
      var path = '/push_manage/file_detail.do'
      var url = addrPre + path
      var param = {taskId: taskId}
      jsonRqes(url, param, callback, error)
    }
    // 推送任务详情
    Vue.prototype.$pushTaskDetail = (orderName, orderType, terminalName, status, page, rows, taskId, callback, error) => {
      var path = '/task_manage/detail_list.do'
      var url = addrPre + path
      var param = {orderName: orderName, orderType: orderType, terminalName: terminalName, status: status, page: page, rows: rows, taskId: taskId}
      jsonRqes(url, param, callback, error)
    }

    // 推送文件下载控制
    Vue.prototype.$pushFileDownCtrl = (id, status, terminalNo, callback, error) => {
      var path = '/task_manage/download_ctrl.do'
      var url = addrPre + path
      var param = {id: id, status: status, terminalNo: terminalNo}
      jsonRqes(url, param, callback, error)
    }
    // 推送删除任务
    Vue.prototype.$pushDelTask = (ids, callback, error) => {
      var path = '/task_manage/del_terminal.do'
      var url = addrPre + path
      var param = {ids: ids}
      jsonRqes(url, param, callback, error)
    }
    // 推送删除所有任务
    Vue.prototype.$pTaskDelall = (taskIds, callback, error) => {
      var path = '/task_manage/del_task.do'
      var url = addrPre + path
      var param = {ids: taskIds}
      jsonRqes(url, param, callback, error)
    }
    // 可推送设备列表
    Vue.prototype.$canPushTer = (page, rows, fileMechId, mechId, terminalStatus, terminalNo, fileType, fileId, callback, error) => {
      var path = '/push_manage/push_terList.do'
      var url = addrPre + path
      var param = {fileId: fileId, fileType: fileType, page: page, rows: rows, fileMechId: fileMechId, mechId: mechId, terminalStatus: terminalStatus, terminalNo: terminalNo}
      jsonRqes(url, param, callback, error)
    }

    // 已推送设备列表
    Vue.prototype.$pushedTerList = (page, rows, fileId, callback, error) => {
      var path = '/push_manage/success_list.do'
      var url = addrPre + path
      var param = {page: page, rows: rows, fileId: fileId}
      jsonRqes(url, param, callback, error)
    }

    // 获取进度条
   /* Vue.prototype.$pushProcess = (page, rows, fileId, callback, error) => {
      // http://113.105.146.93:8080/tms-server-web/terminalManagement/getProgress.do
      var path = '/terminalManagement/getProgress.do'
      var url = addrPre + path
      var param = {page: page, rows: rows, fileId: fileId}
      jsonRqes(url, param, callback, error)
    }*/

    // 推送任务终端回调接口
    Vue.prototype.$pushCallback = (fileNo, status, progress, callback, error) => {
      var path = '/terminalManagement/monitor/retStatus.do'
      var url = addrPre + path
      var param = {fileNo: fileNo, status: status, progress: progress}
      jsonRqes(url, param, callback, error)
    }
    //--------------

    //
    // launcher列表
    Vue.prototype.$launcherList = (page, rows, launcherName, distributorId, orderName, orderType, status, callback, error) => {
      var path = '/launcher/listLauncher.do'
      var url = addrPre + path
      var param = {orderName: orderName, orderType: orderType, page: page, rows: rows, launcherName: launcherName, distributorId: distributorId, status: status}

      jsonRqes(url, param, callback, error)
    }

    // 渠道商订单列表
    Vue.prototype.$channelOrders = (page, rows, orderNo, customerName, callback, error) => {
      var path = '/support/listOrder.do'
      var url = addrPre + path
      var param = {page: page, rows: rows, orderNo: orderNo, customerName: customerName}
      jsonRqes(url, param, callback, error)
    }

    // 渠道商证书列表
    Vue.prototype.$channelCers = (page, rows, customerName, callback, error) => {
      var path = '/support/list.do'
      var url = addrPre + path
      var param = {page: page, rows: rows, customerName: customerName}
      jsonRqes(url, param, callback, error)
    }

    // 测试配置
    Vue.prototype.$fstTest = (id, terminalNo, callback, error) => {
      var path = '/profilesManage/push.do'
      var url = addrPre + path
      var param = {id: id, terminalNo: terminalNo}
      jsonRqes(url, param, callback, error)
    }

    // 配置列表
    Vue.prototype.$fstList = (page, rows, name, callback, error) => {
      var path = '/profilesManage/list.do'
      var url = addrPre + path
      var param = {page: page, rows: rows, name: name}
      jsonRqes(url, param, callback, error)
    }

    // 配置历史列表
    Vue.prototype.$fstHisList = (page, rows, profilesId, callback, error) => {
      var path = '/profilesManage/recordList.do'
      var url = addrPre + path
      var param = {page: page, rows: rows, profilesId: profilesId}
      jsonRqes(url, param, callback, error)
    }

    // 待审配置列表
    Vue.prototype.$fstVList = (page, rows, callback, error) => {
      var path = '/profilesManage/auditList.do'
      var url = addrPre + path
      var param = {page: page, rows: rows}
      jsonRqes(url, param, callback, error)
    }

    // 添加配置
    Vue.prototype.$addFst = (ftpFileName,updateType, id, name, version, flag, curl, key, md5, size, appPackage, memo, callback, error) => {
      var path = '/profilesManage/add.do'
      var url = addrPre + path
      var param = {ftpFileName: ftpFileName, updateType: updateType, id: id, name: name, version: version,flag: flag, url: curl, key: key, md5: md5, size: size, appPackage: appPackage, memo: memo}
      jsonRqes(url, param, callback, error)
    }

    // 编辑配置
    Vue.prototype.$editFst = (ftpFileName, updateType, id, profilesId, name, version, flag, curl, key, md5, size, appPackage, memo, callback, error) => {
      var path = '/profilesManage/edit.do'
      var url = addrPre + path
      var param = {ftpFileName: ftpFileName, updateType: updateType, id: id, name: name, profilesId: profilesId, version: version,flag: flag, url: curl, key: key, md5: md5, size: size, appPackage: appPackage, memo: memo}
      jsonRqes(url, param, callback, error)
    }

    // 删除配置
    Vue.prototype.$delFst = (ids, callback, error) => {
      var path = '/profilesManage/delete.do'
      var url = addrPre + path
      var param = {ids: ids}
      jsonRqes(url, param, callback, error)
    }

    // 删除配置记录terminalNos
    Vue.prototype.$delFstRecord = (ids, callback, error) => {
      var path = '/profilesManage/deleteRecord.do'
      var url = addrPre + path
      var param = {ids: ids}
      jsonRqes(url, param, callback, error)
    }

    // 取配置详情
    Vue.prototype.$getFstDetail = (id, callback, error) => {
      var path = '/profilesManage/detail.do'
      var url = addrPre + path
      var param = {id: id}
      jsonRqes(url, param, callback, error)
    }

    // 系统配置列表
    Vue.prototype.$syscflist = (page, rows, name, callback, error) => {
      var path = '/sysConfig/configList.do'
      var url = addrPre + path
      var param = {page: page, rows: rows, name: name}
      jsonRqes(url, param, callback, error)
    }

    // 重推失败配置
    Vue.prototype.$repushFailSyscf = (rePushId, callback, error) => {
      var path = '/sysConfig/rePush.do'
      var url = addrPre + path
      var param = {rePushId: rePushId}
      jsonRqes(url, param, callback, error)
    }

    // 删除系统配置绑定设备
    Vue.prototype.$delSyscfBindDv = (ids, callback, error) => {
      var path = '/sysConfig/delDevice.do'
      var url = addrPre + path
      var param = {ids: ids}
      jsonRqes(url, param, callback, error)
    }

    // 系统配置设绑列表
    Vue.prototype.$syscfBindlist = (configId, page, rows, terminalNo, mechId, callback, error) => {
      var path = '/sysConfig/pushList.do'
      var url = addrPre + path
      var param = {configId: configId, page: page, rows: rows, terminalNo: terminalNo, mechId: mechId}
      jsonRqes(url, param, callback, error)
    }

    // 添加系统配置
    Vue.prototype.$addSyscf = (configName, address, port, callback, error) => {
      var path = '/sysConfig/addSysConfig.do'
      var url = addrPre + path
      var param = {configName: configName, address: address, port: port}
      jsonRqes(url, param, callback, error)
    }

    // 编辑系统配置
    Vue.prototype.$editSyscf = (id, configName, address, port, callback, error) => {
      var path = '/sysConfig/editSysConfig.do'
      var url = addrPre + path
      var param = {id: id, configName: configName, address: address, port: port}
      jsonRqes(url, param, callback, error)
    }

    // 系统配置详情
    Vue.prototype.$syscfDetail = (id, callback, error) => {
      var path = '/sysConfig/configDetail.do'
      var url = addrPre + path
      var param = {id: id}
      jsonRqes(url, param, callback, error)
    }

    // 删除系统配置
    Vue.prototype.$delSyscf = (ids, callback, error) => {
      var path = '/sysConfig/delSysConfig.do'
      var url = addrPre + path
      var param = {ids: ids}
      jsonRqes(url, param, callback, error)
    }

    // 审核配置
    Vue.prototype.$verifyFst = (id, content, status, callback, error) => {
      var path = '/profilesManage/audit.do'
      var url = addrPre + path
      var param = {id: id, content: content, status: status}
      jsonRqes(url, param, callback, error)
    }

    // 模块操作查询
    Vue.prototype.$mdOpQuery = (terminalNo, callback, error) => {
      var path = '/ter_cmd/modelLogs.do'
      var url = addrPre + path
      var param = {terminalNo: terminalNo}
      jsonRqes(url, param, callback, error)
    }

    // 方法操作查询
    Vue.prototype.$funcOpQuery = (terminalNo, modelName, callback, error) => {
      var path = '/ter_cmd/methodLogs.do'
      var url = addrPre + path
      var param = {terminalNo: terminalNo, modelName: modelName}
      jsonRqes(url, param, callback, error)
    }

    // 围栏未绑定设备s
    Vue.prototype.$unbindDevices = (page, rows, areaid, riskId, terminal_status, terminal_no, callback, error) => {
      var path = '/risk/terminal_list.do'
      var url = addrPre + path
      var param = {areaid: areaid, page: page, rows: rows, riskId: riskId, terminal_status: terminal_status, terminal_no: terminal_no}
      jsonRqes(url, param, callback, error)
    }

    // 交易信息查询
    Vue.prototype.$tradeList = (page, rows, terminalNo, mercId, callback, error) => {
      var path = '/trading/list.do'
      var url = addrPre + path
      var param = {terminalNo: terminalNo, page: page, rows: rows, mercId: mercId}
      jsonRqes(url, param, callback, error)
    }

    // 导出交易报表
    Vue.prototype.$exportTrans = (mcID, termID, type, trId, terminalNo) => {
      var token = localStorage.user ? localStorage.user : ''
      var url = addrPre + `/trading/export.do?mcID=${mcID}&language=`+localStorage.system_lang + `&termID=${termID}&type=${type}&trId=${trId}&terminalNo=${terminalNo}&token=${token}`
      // alert(url)
      window.open(url, '_blank')
    }

    // 视频广告
    Vue.prototype.$videoList = (distributorId, page, rows, videoName, status, callback, error) => {
      var path = '/video/list.do'
      var url = addrPre + path
      var param = {distributorId: distributorId, page: page, rows: rows, videoName: videoName, status: status}
      jsonRqes(url, param, callback, error)
    }

    // 默认视频广告
    Vue.prototype.$defaultVideoList = (distributorId, page, rows, videoName, callback, error) => {
      var path = '/video/listDefault.do'
      var url = addrPre + path
      var param = {distributorId: distributorId, page: page, rows: rows, videoName: videoName}
      jsonRqes(url, param, callback, error)
    }

    // 审核视频广告
    Vue.prototype.$verifyVideo = (videoId, status, refuseReason, callback, error) => {
      var path = '/video/check.do'
      var url = addrPre + path
      var param = {videoId: videoId, status: status, refuseReason: refuseReason}
      jsonRqes(url, param, callback, error)
    }

    // 删除视频广告
    Vue.prototype.$delVideo = (videoId, callback, error) => {
      var path = '/video/delete.do'
      var url = addrPre + path
      var param = {videoId: videoId}
      jsonRqes(url, param, callback, error)
    }

    // 提交视频广告
    Vue.prototype.$submitVideo = (videoId, callback, error) => {
      var path = '/video/subcheck.do'
      var url = addrPre + path
      var param = {videoId: videoId}
      jsonRqes(url, param, callback, error)
    }

    // 添加视频广告
    Vue.prototype.$addVideo = (videoName, curl, duration, distributorId, size, hash, sTime, eTime, dimension, callback, error) => {
      var path = '/video/add.do'
      var url = addrPre + path
      var param = {videoName: videoName, url: curl, duration: duration, distributorId: distributorId, size: size, hash: hash, sTime: sTime, eTime: eTime, dimension: dimension}
      jsonRqes(url, param, callback, error)
    }
     // 添加默认视频广告
     Vue.prototype.$addDefaultVideo = (videoName, curl, duration, distributorId, size, hash, dimension, callback, error) => {
      var path = '/video/addDefault.do'
      var url = addrPre + path
      var param = {videoName: videoName, url: curl, duration: duration, distributorId: distributorId, size: size, hash: hash, dimension: dimension}
      jsonRqes(url, param, callback, error)
    }

    // 编辑视频广告
    Vue.prototype.$editVideo = (videoId, videoName, curl, duration, size, hash, sTime, eTime, dimension, callback, error) => {
      var path = '/video/edit.do'
      var url = addrPre + path
      var param = {videoId: videoId, videoName: videoName, url: curl, duration: duration, size: size, hash: hash, sTime: sTime, eTime: eTime, dimension: dimension}
      jsonRqes(url, param, callback, error)
    }

    // 各种推送记录
    Vue.prototype.$pushRecords = (page, rows, pushName, objectId, callback, error) => {
      var path = '/push_task/push_record.do'
      var url = addrPre + path
      var param = {page: page, rows: rows, pushName: pushName, objectId: objectId}
      jsonRqes(url, param, callback, error)
    }

    // 失败重推
    Vue.prototype.$repush = (pushType, opeTime, objectId, callback, error) => {
      var path = '/push_task/re_push.do'
      var url = addrPre + path
      var param = {pushType: pushType, opeTime: opeTime, objectId: objectId}
      jsonRqes(url, param, callback, error)
    }


    // launcher审核列表
    Vue.prototype.$launchVerifyList = (page, rows, distributorId, orderName, orderType, callback, error) => {
      var path = '/launcher/listCheck.do'
      var url = addrPre + path
      var param = {orderName: orderName, orderType: orderType, page: page, rows: rows, distributorId: distributorId}

      jsonRqes(url, param, callback, error)
    }

     // 添加launcher
     Vue.prototype.$addLauncher = (md5, launcherName, launcherDesc, launcherImg, launcherUrl, packageName, version, versionCode, appSize, distributorId, callback, error) => {
      var path = '/launcher/addLauncher.do'
      var url = addrPre + path
      var param = {md5: md5, launcherName: launcherName, launcherDesc: launcherDesc, launcherImg: launcherImg, launcherUrl: launcherUrl, packageName: packageName, version: version, versionCode: versionCode, appSize: appSize, distributorId: distributorId}

      jsonRqes(url, param, callback, error)
    }

    // 编辑launcher
    Vue.prototype.$editLauncher = (md5, launcherName, launcherDesc, launcherImg, launcherUrl, packageName, version, versionCode, appSize, launcherId, callback, error) => {
      var path = '/launcher/editLauncher.do'
      var url = addrPre + path
      var param = {md5: md5, launcherName: launcherName, launcherDesc: launcherDesc, launcherImg: launcherImg, launcherUrl: launcherUrl, packageName: packageName, version: version, versionCode: versionCode, appSize: appSize, launcherId: launcherId}

      jsonRqes(url, param, callback, error)
    }

    // 删除launcher
    Vue.prototype.$delLauncher = (launcherId,  status, callback, error) => {
      var path = '/launcher/deleteLauncher.do'
      var url = addrPre + path
      var param = {launcherId: launcherId, status: status}

      jsonRqes(url, param, callback, error)
    }

    // 删除launcher历史
    Vue.prototype.$delLauncherHistory = (versionId, callback, error) => {
      var path = '/launcher/deleteVersion.do'
      var url = addrPre + path
      var param = {versionId: versionId}
      jsonRqes(url, param, callback, error)
    }

    // 推送launcher
    Vue.prototype.$pushLauncher = (launcherId, terminalNo, distributorId, callback, error) => {
      var path = '/launcher/push.do'
      var url = addrPre + path
      var param = {launcherId: launcherId, terminalNo: terminalNo, distributorId: distributorId}
      jsonRqes(url, param, callback, error)
    }

    // 还原launcher
    Vue.prototype.$resetLauncher = (packageName, terminalNo, callback, error) => {
      var path = '/launcher/reduction.do'
      var url = addrPre + path
      var param = {packageName: packageName, terminalNo: terminalNo}
      jsonRqes(url, param, callback, error)
    }

    // 获取launcher绑定设备
    Vue.prototype.$getLauncherDevices = (page, rows, launcherId, distributorId, packageName, callback, error) => {
      var path = '/launcher/listTerminalBylauncher.do'
      var url = addrPre + path
      var param = {page: page, rows: rows, launcherId: launcherId, distributorId: distributorId, packageName: packageName}
      jsonRqes(url, param, callback, error)
    }

    // 提交审核launcher
    Vue.prototype.$submitLauncher = (launcherId, callback, error) => {
      var path = '/launcher/submitCheck.do'
      var url = addrPre + path
      var param = {launcherId: launcherId}

      jsonRqes(url, param, callback, error)
    }

    // launcher历史版本
    Vue.prototype.$launcherHistory = (launcherId, callback, error) => {
      var path = '/launcher/listVersion.do'
      var url = addrPre + path
      var param = {launcherId: launcherId}

      jsonRqes(url, param, callback, error)
    }

    // 审核launcher
    Vue.prototype.$verifyLauncher = (launcherId, refuseReason, status, versionCode, callback, error) => {
      var path = '/launcher/check.do'
      var url = addrPre + path
      var param = {launcherId: launcherId, refuseReason: refuseReason, status: status, versionCode: versionCode}

      jsonRqes(url, param, callback, error)
    }

    // 更新launcher
    Vue.prototype.$updateLauncher = (md5, launcherName, launcherDesc, launcherImg, launcherUrl, packageName, version, versionCode, appSize, launcherId, distributorId, callback, error) => {
      var path = '/launcher/uploadVersion.do'
      var url = addrPre + path
      var param = {md5: md5, launcherName: launcherName, launcherDesc: launcherDesc, launcherImg: launcherImg, launcherUrl: launcherUrl, packageName: packageName, version: version, versionCode: versionCode, appSize: appSize, launcherId: launcherId, distributorId: distributorId}

      jsonRqes(url, param, callback, error)
    }

    // launcher推送列表
    Vue.prototype.$pushLauncherList = (page, rows, distributorId, terminal_no, terminal_status, terminal_runtime_status, launcherId, callback, error) => {
      var path = '/launcher/listTerminalNolauncher.do'
      var url = addrPre + path
      var param = {page: page, rows: rows, distributorId: distributorId, terminal_no: terminal_no, terminal_status: terminal_status, terminal_runtime_status: terminal_runtime_status, launcherId: launcherId}

      jsonRqes(url, param, callback, error)
    }

    // 渠道商详情
    Vue.prototype.$getChannelCer = (distributorId, callback, error) => {
      var path = '/support/listCertificate.do'
      var url = addrPre + path
      jsonRqes(url, {distributorId: distributorId}, callback, error)
    }

    // 获取渠道商厂商设备类型等信息
    Vue.prototype.$getMcTypeInfo = (mid, callback, error) => {
      var path = '/mechanism/baseInfo.do'
      var url = addrPre + path
      jsonRqes(url, {id: mid}, callback, error)
    }

    // 导入产线证书
    Vue.prototype.$importLineCer = (id, distributorId, callback, error) => {
      var path = '/support/importCertificate.do'
      var url = addrPre + path
      jsonRqes(url, {distributorId: distributorId, id: id}, callback, error)
    }

    // 删除证书
    Vue.prototype.$delcer = (id, callback, error) => {
      var path = '/cer/deleteCertificate.do'
      var url = addrPre + path
      jsonRqes(url, {id: id}, callback, error)
    }

    // 导入产线订单
    Vue.prototype.$importLineOrder = (orderNo, distributorId, manufid, terminal_type, terminal_model, terminal_address, callback, error) => {
      var path = '/support/importTerminalByOrder.do'
      var url = addrPre + path
      jsonRqes(url, {manufid: manufid, terminal_type: terminal_type, terminal_model: terminal_model, terminal_address: terminal_address, distributorId: distributorId, orderNo: orderNo}, callback, error)
    }

    // 上传证书
    Vue.prototype.$uploadCer = (cer_url, privkey_url, certificateId, certificateName, certificateDesc, distributorId, callback, error) => {
      var path = '/cer/addCertificate.do'
      var url = addrPre + path
      var param = {privkey_url: privkey_url, cer_url: cer_url, certificateId: certificateId, certificateName: certificateName, certificateDesc: certificateDesc, distributorId: distributorId}

      jsonRqes(url, param, callback, error)
    }
    // 添加动画
    Vue.prototype.$addAnimate = (md5, animatName, animatType, position, animatUrl, size, speed, times, logoUrl, callback, error) => {
      var path = '/boot_animat/makeAnimat.do'
      var url = addrPre + path
      var param = {md5: md5, animatName: animatName, animatType: animatType, position: position, animatUrl: animatUrl, size: size, speed: speed, times: times, logoUrl: logoUrl}

      jsonRqes(url, param, callback, error)
    }
    // 删除动画
    Vue.prototype.$delAnimate = (animatId, callback, error) => {
      var path = '/boot_animat/delAnimat.do'
      var url = addrPre + path
      jsonRqes(url, {animatId: animatId}, callback, error)
    }
    // 推送动画
    Vue.prototype.$pushAnimate = (terminalNo, type, fileNo, memo, mechanismId, animatId, callback, error) => {
      var path = '/boot_animat/addTerAnimat.do'
      var url = addrPre + path
      var param = {terminalNo: terminalNo, type: type, fileNo: fileNo ,memo: memo, mechanismId: mechanismId, animatId: animatId}

      jsonRqes(url, param, callback, error)
    }

    // 根据fileId查询推送历史 (通用版)
    Vue.prototype.$getPushHistory = (param, callback, error) => {
      var path = '/push_manage/success_list.do'
      var url = addrPre + path
      jsonRqes(url, param, callback, error)
    }

    // 推送动画历史
    Vue.prototype.$pushAnimateHistory = (animatId, callback, error) => {
      var path = '/boot_animat/terAnimatList.do'
      var url = addrPre + path
      jsonRqes(url, {animatId: animatId}, callback, error)
    }
    // 清除推送动画历史
    Vue.prototype.$delAnimatePushHis = (mechanismId, animatId, callback, error) => {
      var path = '/boot_animat/delTerAnimat.do'
      var url = addrPre + path
      jsonRqes(url, {animatId: animatId, mechanismId: mechanismId}, callback, error)
    }
    // 查渠道商设备数量
    Vue.prototype.$getChannelDevices = (mechanismId, callback, error) => {
      var path = '/terminal/terNums.do'
      var url = addrPre + path
      var param = {mechanismId: mechanismId}
      // console.log(url, param)
      jsonRqes(url, param, callback, error)
    }
    // 查询动画列表
    Vue.prototype.$animateList = (rows, page, callback, error) => {
      var path = '/boot_animat/animatList.do'
      var url = addrPre + path
      jsonRqes(url, {rows: rows, page: page}, callback, error)
    }
    // 查询厂商列表
    Vue.prototype.$getFirmList = (rows, page, orderName, orderType, callback, error) => {
      var path = '/manufacturers/list.do'
      var url = addrPre + path
      var param = {rows: rows, page: page, orderName: orderName, orderType: orderType}

      jsonRqes(url, param, callback, error)
    }
    // 删除厂商
    Vue.prototype.$deleteFirm = (ids, callback, error) => {
      var path = '/manufacturers/delete.do'
      var url = addrPre + path
      jsonRqes(url, {ids: ids}, callback, error)
    }
    // 添加厂商
    Vue.prototype.$addFirm = (name, contacts, telephone, address, callback, error) => {
      var path = '/manufacturers/add.do'
      var url = addrPre + path

      jsonRqes(url, {name: name, contacts: contacts, telephone: telephone, address: address}, callback, error)
    }
    // 修改厂商
    Vue.prototype.$editFirm = (id, name, contacts, telephone, address, createTime, callback, error) => {
      var path = '/manufacturers/edit.do'
      var url = addrPre + path

      jsonRqes(url, {id: id, name: name, contacts: contacts, telephone: telephone, address: address, createTime: createTime}, callback, error)
    }
    // 设备类型列表
    Vue.prototype.$deviceType = (rows, page, orderName, orderType, callback, error) => {
      var path = '/terminalType/list.do'
      var url = addrPre + path
      var param = {orderType: orderType, orderName: orderName, rows: rows, page: page}

      jsonRqes(url, param, callback, error)
    }
    // 添加设备类型
    Vue.prototype.$addDeviceType = (name, callback, error) => {
      var path = '/terminalType/add.do'
      var url = addrPre + path
      jsonRqes(url, {name: name}, callback, error)
    }
    // 修改设备类型
    Vue.prototype.$editDeviceType = (id, name, callback, error) => {
      var path = '/terminalType/edit.do'
      var url = addrPre + path
      jsonRqes(url, {id: id, name: name}, callback, error)
    }
    // 删除设备类型
    Vue.prototype.$delDeviceType = (ids, callback, error) => {
      var path = '/terminalType/delete.do'
      var url = addrPre + path
      var param = {ids: ids}
      // console.log(param)
      jsonRqes(url, param, callback, error)
    }
    // 设备型号
    Vue.prototype.$deviceNo = (rows, page, orderName, orderType, callback, error) => {
      var path = '/terminalModel/list.do'
      var url = addrPre + path
      var param = {rows: rows, page: page, orderName: orderName, orderType: orderType}

      jsonRqes(url, param, callback, error)
    }
    // 添加设备型号
    Vue.prototype.$addDeviceNo = (name, callback, error) => {
      var path = '/terminalModel/add.do'
      var url = addrPre + path
      jsonRqes(url, {name: name}, callback, error)
    }
    // 删除设备型号
    Vue.prototype.$delDeviceNo = (ids, callback, error) => {
      var path = '/terminalModel/delete.do'
      var url = addrPre + path
      var param = {ids: ids}
      // console.log(param)
      jsonRqes(url, param, callback, error)
    }
    // 修改设备型号
    Vue.prototype.$editDeviceNo = (id, name, callback, error) => {
      var path = '/terminalModel/edit.do'
      var url = addrPre + path
      var param = {id: id, name: name}

      jsonRqes(url, param, callback, error)
    }
    // 广告类型列表
    Vue.prototype.$adTypeList = (rows, page, orderName, orderType, callback, error) => {
      var path = '/adType/list.do'
      var url = addrPre + path
      var param = {orderType: orderType, orderName: orderName, rows: rows, page: page}

      jsonRqes(url, param, callback, error)
    }
    // 添加广告类型
    Vue.prototype.$addAdType = (name, callback, error) => {
      var path = '/adType/add.do'
      var url = addrPre + path
      jsonRqes(url, {name: name}, callback, error)
    }
    // 删除广告类型
    Vue.prototype.$delAdType = (ids, callback, error) => {
      var path = '/adType/delete.do'
      var url = addrPre + path
      var param = {ids: ids}
      // console.log(param)
      jsonRqes(url, param, callback, error)
    }
    // 修改广告类型
    Vue.prototype.$editAdType = (id, name, callback, error) => {
      var path = '/adType/edit.do'
      var url = addrPre + path
      var param = {id: id, name: name}

      jsonRqes(url, param, callback, error)
    }
		
		// PSP应用列表
		Vue.prototype.$pspList = (data, callback, error) => {
		  var path = '/pspApp/list.do'
		  var url = addrPre + path
		  var data = data
		
		  jsonRqes(url, data, callback, error)
		}
		// 添加PSP应用
		Vue.prototype.$addPsp = (data, callback, error) => {
		  var path = '/pspApp/add.do'
		  var url = addrPre + path
		  var data = data
		
		  jsonRqes(url, data, callback, error)
		}
		// 编辑PSP应用
		Vue.prototype.$editPsp = (data, callback, error) => {
		  var path = '/pspApp/edit.do'
		  var url = addrPre + path
		  var data = data
		
		  jsonRqes(url, data, callback, error)
		}
		// 删除PSP应用
		Vue.prototype.$delPsp = (ids, callback, error) => {
		  var path = '/pspApp/delete.do'
		  var url = addrPre + path
		  var param = {ids: ids}
		  jsonRqes(url, param, callback, error)
		}
		// 应用设备更新列表
		Vue.prototype.$pspUpdateList = (data, callback, error) => {
		  var path = '/pspApp/updateList.do'
		  var url = addrPre + path
		  var data = data
		
		  jsonRqes(url, data, callback, error)
		}
		
		
		// PSP卸载应用列表
		Vue.prototype.$pspUnList = (data, callback, error) => {
		  var path = '/pspUninstallApp/list.do'
		  var url = addrPre + path
		  var data = data
		
		  jsonRqes(url, data, callback, error)
		}
		// PSP卸载推送
		Vue.prototype.$pspUnPush = (data, callback, error) => {
		  var path = '/pspUninstallApp/push.do'
		  var url = addrPre + path
		  var data = data
		
		  jsonRqes(url, data, callback, error)
		}
		// PSP卸载删除
		Vue.prototype.$delUnPsp = (ids, callback, error) => {
		  var path = '/pspUninstallApp/delete.do'
		  var url = addrPre + path
		  var param = {ids: ids}
		  jsonRqes(url, param, callback, error)
		}
		// PSP卸载删除
		Vue.prototype.$delUnPspAll = (data, callback, error) => {
		  var path = '/pspUninstallApp/delAll.do'
		  var url = addrPre + path
		  var data = data
		  jsonRqes(url, data, callback, error)
		}
		
		
		// 修改PSP列表
		Vue.prototype.$changePspList = (data, callback, error) => {
		  var path = '/pspChangeApp/list.do'
		  var url = addrPre + path
		  var data = data
		
		  jsonRqes(url, data, callback, error)
		}
		// 新增修改PSP
		Vue.prototype.$changePspAdd = (data, callback, error) => {
		  var path = '/pspChangeApp/add.do'
		  var url = addrPre + path
		  var data = data
		
		  jsonRqes(url, data, callback, error)
		}
		// 删除修改PSP
		Vue.prototype.$delChangePsp = (ids, callback, error) => {
		  var path = '/pspChangeApp/delete.do'
		  var url = addrPre + path
		  var param = {ids: ids}
		  jsonRqes(url, param, callback, error)
		}
		// 修改PSP设备列表
		Vue.prototype.$changePspDeviceList = (data, callback, error) => {
		  var path = '/pspChangeApp/pushList.do'
		  var url = addrPre + path
		  var data = data
		  jsonRqes(url, data, callback, error)
		}
		// 修改PSP推送
		Vue.prototype.$changePspPush = (data, callback, error) => {
		  var path = '/pspChangeApp/push.do'
		  var url = addrPre + path
		  var data = data
		  jsonRqes(url, data, callback, error)
		}
		// 修改PSP删除
		Vue.prototype.$changePspDel = (ids, callback, error) => {
		  var path = '/pspChangeApp/deleteTask.do'
		  var url = addrPre + path
		  var param = {ids: ids}
		  jsonRqes(url, param, callback, error)
		}
		// 修改PSP删除全部
		Vue.prototype.$changePspDelAll = (data, callback, error) => {
		  var path = '/pspChangeApp/delAllTask.do'
		  var url = addrPre + path
		  var data = data
		  jsonRqes(url, data, callback, error)
		}
		
		
		
		
     // 应用类型列表
    Vue.prototype.$appTypeList = (rows, page, orderName, orderType, callback, error) => {
      var path = '/appType/list.do'
      var url = addrPre + path
      var param = {orderName: orderName, orderType: orderType, rows: rows, page: page}

      jsonRqes(url, param, callback, error)
    }
    // 添加应用类型
    Vue.prototype.$addAppType = (name, callback, error) => {
      var path = '/appType/add.do'
      var url = addrPre + path
      jsonRqes(url, {name: name}, callback, error)
    }
    // 删除应用类型
    Vue.prototype.$delAppType = (ids, callback, error) => {
      var path = '/appType/delete.do'
      var url = addrPre + path
      var param = {ids: ids}
      // console.log(param)
      jsonRqes(url, param, callback, error)
    }
    // 修改应用类型
    Vue.prototype.$editAppType = (id, name, callback, error) => {
      var path = '/appType/edit.do'
      var url = addrPre + path
      var param = {id: id, name: name}
      // console.log(url, param)
      jsonRqes(url, param, callback, error)
    }
	// 删除任务详情设备
	Vue.prototype.$delTaskDevice = (data, callback, error) => {
	  var path = '/task_manage/delAll.do'
	  var url = addrPre + path
	  var data = data
	  jsonRqes(url, data, callback, error)
	}
    // 任务列表
    Vue.prototype.$missionList = (rows, page, userId, mechId, taskName, callback, error) => {
      var path = '/push_task/countList.do'
      var url = addrPre + path
      var param = {rows: rows, page: page, userId: userId, mechId: mechId, taskName: taskName}

      jsonRqes(url, param, callback, error)
    }
    // 推送任务列表
    Vue.prototype.$pushTaskList = (rows, page, terminalNo, taskType, fileName, callback, error) => {
      var path = '/task_manage/ter_task_list.do'
      var url = addrPre + path
      var param = {rows: rows, page: page, terminalNo: terminalNo, taskType: taskType, fileName: fileName}

      jsonRqes(url, param, callback, error)
    }
    // 任务详情
    Vue.prototype.$missionDetail = (fileName, rows, page, pushName, terminalNo, status, mechanismId, callback, error) => {
      var path = '/push_task/detailList.do'
      var url = addrPre + path
      var param = {fileName: fileName, rows: rows, page: page, pushName: pushName, terminalNo: terminalNo, status: status, mechanismId: mechanismId}
      console.log(url, param)
      jsonRqes(url, param, callback, error)
    }
    // 任务进度
    Vue.prototype.$missionPersent = (fileNo, callback, error) => {
      var path = '/terminalManagement/getProgress.do'
      var url = addrPre + path
      var param = {fileNo: fileNo}
      // console.log(url, param)
      jsonRqes(url, param, callback, error)
    }
    // 删除下载任务
    Vue.prototype.$delMission = (ids, callback, error) => {
      var path = '/push_task/delete.do'
      var url = addrPre + path
      var param = {ids: ids}
      // console.log(url, param)
      jsonRqes(url, param, callback, error)
    }
    // 下载控制
    Vue.prototype.$missionOperate = (terminalNo, id, status, callback, error) => {
      var path = '/push_task/download.do'
      var url = addrPre + path
      // 1继续、2暂停、3取消
      var param = {id: id, status: status, terminalNo: terminalNo}

      jsonRqes(url, param, callback, error)
    }
     // 获取设备列表
    Vue.prototype.$getDvDevices = (page, row, areaid, tNo, tStatus, tRunTimeStatus,orderType, time_orderType,snBegin,snEnd, callback, error) => {
      var url = wUrl.host + wUrl.port + wUrl.path +'/terminal/list.do'
      var param = {time_orderType: time_orderType, orderType: orderType, page: page,rows: row, areaid: areaid, terminal_no: tNo, terminal_status: tStatus, terminal_runtime_status: tRunTimeStatus,snBegin:snBegin,snEnd:snEnd}

      jsonRqes(url, param, callback, error)
    }
	// 获取设备列表 
	Vue.prototype.$get_device_list = (page, row,secretKeyDownload,secretKeyExist, areaid, tNo, tStatus, tRunTimeStatus,orderType, time_orderType, callback, error) => {
	  var url = wUrl.host + wUrl.port + wUrl.path +'/kmc/terminalList.do'
	  var param = {time_orderType: time_orderType, orderType: orderType, page: page,rows: row,secretKeyDownload:secretKeyDownload,secretKeyExist:secretKeyExist, areaid: areaid, terminalNo: tNo, status: tStatus, terminal_runtime_status: tRunTimeStatus}
	
	  jsonRqes(url, param, callback, error)
	}
    // 获取设备列表
    Vue.prototype.$getDevices = (page, row, areaid, tNo, tStatus, tRunTimeStatus, appId, callback, error) => {
      // var url = 'http://113.105.146.93:7878/zttms/terminalManagement/terminal/queryCon?jsondata='
      var url = wUrl.host + wUrl.port + wUrl.path +'/appDistribute/terminalList.do'
      var param = {page: page,rows: row, areaid: areaid, terminal_no: tNo, terminal_status: tStatus, terminal_runtime_status: tRunTimeStatus, appId: appId}
      // param = JSON.stringify(param)
      // param = encodeURIComponent(param)

      jsonRqes(url, param, callback, error)
    }
    // 获取设备列表1
    Vue.prototype.$getDevices1 = (page, row, areaid, tNo, tStatus, tRunTimeStatus, appId, callback, error) => {
      var url = appUrlPre +'/appDistribute/getTerminalList.do'
      var param = {page: page,rows: row, areaid: areaid, terminal_no: tNo, terminal_status: tStatus, terminal_runtime_status: tRunTimeStatus, appId: appId}
      // param = JSON.stringify(param)
      // param = encodeURIComponent(param)
      // console.log(url, param)
      jsonRqes(url, param, callback, error)
    }
    // 获取设备安装列表
    Vue.prototype.$getTerInstallList = (page, rows, distributorId, appName, terminalId, callback, error) => {
      var url = appUrlPre +'/appDistribute/getTerminalAppList.do'
      var param = {page: page,rows: rows, distributorId: distributorId, terminalId: terminalId, appName: appName}
      // param = JSON.stringify(param)
      // param = encodeURIComponent(param)
      // console.log(url, param)
      jsonRqes(url, param, callback, error)
    }
    // 上级渠道商列表
    Vue.prototype.$parentChannel = (page, rows, callback, error) => {
      var path = '/mechanism/parent_list.do'
      var url = addrPre + path
      var param = {page: page, rows: rows}
      // console.log(url, param)
      jsonRqes(url, param, callback, error)
    }
    // 渠道商详情
    Vue.prototype.$getMcDetail = (id, callback, error) => {
      var path = '/mechanism/detail.do'
      var url = addrPre + path
      var param = {id: id}
      // console.log(url, param)
      jsonRqes(url, param, callback, error)
    }
    // 获取渠道商列表
    Vue.prototype.$getChannelList = (rows, page, mechId, certType, mechanismName, callback, error) => {
      var path = '/mechanism/list.do'
      var url = addrPre + path
      var param = {mechId: mechId, rows: rows, page: page, certType: certType, mechanismName: mechanismName}

      jsonRqes(url, param, callback, error)
    }
    // 删除渠道商
    Vue.prototype.$deleteChannel = (ids, callback, error) => {
      var path = '/mechanism/delete.do'
      var url = addrPre + path
      var param = {ids: ids}

      jsonRqes(url, param, callback, error)
    }
    // 添加渠道商
    Vue.prototype.$addChannel = (certType, superId, mechanismGrade, mechanismName, mechanismAddre, completeName, mechanismCode, memo, callback, error) => {
      var path = '/mechanism/add.do'
      var url = addrPre + path
      var param = {certType: certType, mechanismName: mechanismName, mechanismAddre: mechanismAddre, memo: memo, completeName: completeName, mechanismCode: mechanismCode, superId: superId, mechanismGrade: mechanismGrade}

      jsonRqes(url, param, callback, error)
    }
    // 修改渠道商
    Vue.prototype.$editChannel = (certType, id, mechanismName, superId, mechanismGrade, mechanismAddre, memo, completeName, mechanismCode, callback, error) => {
      var path = '/mechanism/edit.do'
      var url = addrPre + path
      var param = {certType: certType, id: id, mechanismName: mechanismName, superId: superId, mechanismGrade: mechanismGrade, mechanismAddre: mechanismAddre, memo: memo, completeName: completeName, mechanismCode: mechanismCode}
      //console.log("param>>>>")
      //console.log(JSON.stringify(param,null,2))
      jsonRqes(url, param, callback, error)
    }
    // 获取应用类型
    Vue.prototype.$getAppTypeList = (rows, page, callback, error) => {
      var path = '/appType/list.do'
      var url = addrPre + path
      jsonRqes(url, {rows: rows, page: page}, callback, error)
    }
    // 查询设备类型
    Vue.prototype.$getDeviceTypeList = (rows, page, callback, error) => {
      var path = '/ terminalType /list.do'
      var url = addrPre + path
      jsonRqes(url, {rows: rows, page: page}, callback, error)
    }
    // 获取我的分发列表
    Vue.prototype.$getDistributeAppList = (appName, appCategoryId, rows, page, distributorId, callback, error) => {
      var path = '/appDistribute/list.do'
      var url = addrPre + path
      var param = {rows: rows, page: page, distributorId: distributorId, appName: appName, appCategoryId: appCategoryId}

      jsonRqes(url, param, callback, error)
    }
    // 获取我的分发列表1
    Vue.prototype.$getDistributeAppList1 = (appName, appCategoryId, rows, page, distributorId, orderName, orderType, callback, error) => {
      var path = '/appDistribute/list.do'
      var url = appUrlPre + path
      var param = {orderType: orderType, orderName: orderName, rows: rows, page: page, distributorId: distributorId, appName: appName, appCategoryId: appCategoryId}

      jsonRqes(url, param, callback, error)
    }
    // 应用详情
    Vue.prototype.$appDetail = (appId, callback, error) => {
      var path = '/app/detail.do'
      //appUrlPre
      // var url = wUrl.host + wUrl.port + path
      var url = appUrlPre + path
      var param = {appId: appId}
      jsonRqes(url, param, callback, error)
    }
    // 应用市场详情
    Vue.prototype.$appMkDetail = (appId, callback, error) => {
      var path = '/appDistribute/detail.do'
      var url = appUrlPre + path
      var param = {appId: appId}
      jsonRqes(url, param, callback, error)
    }
    // 推荐到首页
    Vue.prototype.$recommendHome = (distributorId, appId, isHome, callback, error) => {
      var path = '/appDistribute/isHome.do'
      var url = addrPre + path
      var param = {distributorId: distributorId, appId: appId, isHome: isHome}
      jsonRqes(url, param, callback, error)
    }
    // 推荐到首页1
    Vue.prototype.$recommendHome1 = (distributorId, appId, isHome, callback, error) => {
      var path = '/appDistribute/isHome.do'
      var url = appUrlPre + path
      var param = {distributorId: distributorId, appId: appId, isHome: isHome}
      jsonRqes(url, param, callback, error)
    }
    // 推荐到分类
    Vue.prototype.$recommendClass = (distributorId, appId, isType, callback, error) => {
      var path = '/appDistribute/isType.do'
      var url = addrPre + path
      var param = {distributorId: distributorId, appId: appId, isType: isType}

      jsonRqes(url, param, callback, error)
    }
    // 推荐到分类1
    Vue.prototype.$recommendClass1 = (distributorId, appId, isType, callback, error) => {
      var path = '/appDistribute/isType.do'
      var url = appUrlPre + path
      var param = {distributorId: distributorId, appId: appId, isType: isType}

      jsonRqes(url, param, callback, error)
    }
    // 获取绑定设备列表
    Vue.prototype.$getAppBindDevices = (rows, page, packageName,appId, distributorId, callback, error) => {
      var path = '/appDistribute/getAppBindList.do'
      var url = addrPre + path
      var param = {packageName: packageName, rows: rows, page: page, appId: appId, distributorId: distributorId}

      jsonRqes(url, param, callback, error)
    }
    // 获取绑定设备列表1
    Vue.prototype.$getAppBindDevices1 = (rows, page, packageName,appId, distributorId, callback, error) => {
      var path = '/appDistribute/getAppBindList.do'
      var url = appUrlPre + path
      var param = {packageName: packageName, rows: rows, page: page, appId: appId, distributorId: distributorId}

      jsonRqes(url, param, callback, error)
    }
    // 绑定设备
    Vue.prototype.$bindApp = (status, terminalId, appId, callback, error) => {
      var path = '/appDistribute/bindApp.do'
      var url = addrPre + path
      var param = {status: status, terminalId: terminalId, appId: appId}
      console.log(url, param)
      jsonRqes(url, param, callback, error)
    }
    // 绑定设备1
    Vue.prototype.$bindApp1 = (distributorId, terminalNo, appId, callback, error) => {
      var path = '/appDistribute/bindApp.do'
      var url = appUrlPre + path
      var param = {distributorId: distributorId, terminalNo: terminalNo, appId: appId}
      jsonRqes(url, param, callback, error)
    }
    // 解绑设备
    Vue.prototype.$unbind = (terminalNo, version, packageName, callback, error) => {
      var path = '/appDistribute/unbind.do'
      var url = appUrlPre + path
      var param = {version: version, terminalNo: terminalNo, packageName: packageName}

      jsonRqes(url, param, callback, error)
    }
    // 添加应用到分发列表
    Vue.prototype.$addAppToDistributeList = (appId, distributorId, callback, error) => {
      var path = '/appDistribute/addApptoMarket.do'
      var url = addrPre + path
      var param = {appId: appId, distributorId: distributorId}

      jsonRqes(url, param, callback, error)
    }
    // 添加应用到分发列表1
    Vue.prototype.$addAppToDistributeList1 = (appId, distributorId, callback, error) => {
      var path = '/appDistribute/addApptoMarket.do'
      var url = appUrlPre + path
      var param = {appId: appId, distributorId: distributorId}

      jsonRqes(url, param, callback, error)
    }
    // 应用上下架
    Vue.prototype.$appDistributeOnOff = (distributorId, packageName, status, callback, error) => {
      var path = '/appDistribute/editGoodsshelves.do'
      var url = addrPre + path
      jsonRqes(url, {distributorId: distributorId, packageName: packageName, status: status}, callback, error)
    }
    // 应用上下架1
    Vue.prototype.$appDistributeOnOff1 = (distributorId, packageName, status, callback, error) => {
      var path = '/appDistribute/editGoodsshelves.do'
      var url = appUrlPre + path
      jsonRqes(url, {distributorId: distributorId, packageName: packageName, status: status}, callback, error)
    }
    // 获取固件列表
    Vue.prototype.$getFirmwareList = (rows, page, mechanismId, firmwareName, type, status, callback, error) => {
      var path = '/firmwareInfo/list.do'
      var url = addrPre + path
      var param = {mechanismId: mechanismId, rows: rows, page: page, firmwareName: firmwareName, type: type, status: status}

      jsonRqes(url, param, callback, error)
    }
    // 上传固件
    Vue.prototype.$uploadFirmware = (md5, mechanismName, mechanismId, firmwareName, type, iurl, version, callback, error) => {
      var path = '/firmwareInfo/add.do'
      var url = addrPre + path
      var param = {md5: md5, mechanismName: mechanismName, mechanismId: mechanismId,firmwareName: firmwareName, type: type, url: iurl, version: version}

      jsonRqes(url, param, callback, error)
    }
    // 编辑固件
    Vue.prototype.$editFirmware = (md5, id, firmwareName, iurl, version, type, mechanismId, mechanismName, callback, error) => {
      var path = '/firmwareInfo/edit.do'
      var url = addrPre + path
      var param = {md5: md5, id: id, firmwareName: firmwareName,url: iurl, version: version, type: type, mechanismId: mechanismId, mechanismName: mechanismName}

      jsonRqes(url, param, callback, error)
    }
    // 删除固件
    Vue.prototype.$deleteFirmware = (ids, callback, error) => {
      var path = '/firmwareInfo/delete.do'
      var url = addrPre + path
      var param = {ids: ids}

      jsonRqes(url, param, callback, error)
    }
    // 审核固件
    Vue.prototype.$checkFirmware = (firmwareId, content, status, callback, error) => {
      var path = '/firmwareInfo/add_audit.do'
      var url = addrPre + path
      var param = {firmwareId: firmwareId, content: content, status: status}

      jsonRqes(url, param, callback, error)
    }
    // 推送固件
    Vue.prototype.$pushFirmware = (fileNo, firmwareId, type, targetId, callback, error) => {
      var path = '/firmwareInfo/push.do'
      var url = addrPre + path
      var param = {fileNo: fileNo, firmwareId: firmwareId, type: type, targetId: targetId}

      jsonRqes(url, param, callback, error)
    }
    // 获取应用列表
    Vue.prototype.$getAppList = (rows, page,distributorId, appCategoryId, appName, appStatus, callback, error) => {
      var path = '/app/list.do'
      var url = addrPre + path
      var param = {distributorId: distributorId, rows: rows, page: page, appCategoryId: appCategoryId, appName: appName, appStatus: appStatus}

      jsonRqes(url, param, callback, error)
    }
    // 获取应用列表1
    Vue.prototype.$getAppList1 = (rows, page,distributorId, appCategoryId, appName, appStatus, orderName, orderType,packageName, callback, error) => {
      var path = '/app/list.do'
      var url = appUrlPre + path
      var param = {orderType: orderType, orderName: orderName, distributorId: distributorId, rows: rows, page: page, appCategoryId: appCategoryId, appName: appName, appStatus: appStatus,packageName: packageName}

      jsonRqes(url, param, callback, error)
    }
    // 获取添加定制应用列表
    Vue.prototype.$getDAppList = (rows, page, appCategoryId, appName, appStatus, distributorId, appId, callback, error) => {
      var path = '/appDistribute/getAppDistributeList.do'
      var url = addrPre + path
      var param = {rows: rows, page: page, appCategoryId: appCategoryId, appName: appName, appStatus: appStatus, distributorId: distributorId}

      jsonRqes(url, param, callback, error)
    }
    // 获取添加定制应用列表1
    Vue.prototype.$getDAppList1 = (rows, page, appCategoryId, appName, appStatus, distributorId, appId, callback, error) => {
      var path = '/appDistribute/getAppDistributeList.do'
      var url = appUrlPre + path
      var param = {rows: rows, page: page, appCategoryId: appCategoryId, appName: appName, appStatus: appStatus, distributorId: distributorId}

      jsonRqes(url, param, callback, error)
    }
    // 获取审核应用列表
    Vue.prototype.$getAppCheckList = (rows, page, appCategoryId, appName, appStatus, callback, error) => {
      var path = '/app/listByCheck.do'
      var url = addrPre + path
      jsonRqes(url, {rows: rows, page: page, appCategoryId: appCategoryId, appName: appName, appStatus: appStatus}, callback, error)
    }
    // 获取审核应用列表1
    Vue.prototype.$getAppCheckList1 = (rows, page, appCategoryId, appName, appStatus, callback, error) => {
      var path = '/app/listByCheck.do'
      var url = appUrlPre + path
      jsonRqes(url, {rows: rows, page: page, appCategoryId: appCategoryId, appName: appName, appStatus: appStatus}, callback, error)
    }
    // 上传应用
    Vue.prototype.$uploadApp = (md5, distributorId, versionCode, packageName, appSize, appUrl, bigIcon, smallIcon, appCategoryId, desc, installType, appName, appScreenShot, appVersion, callback, error) => {
      var path = '/app/add.do'
      var url = addrPre + path
      var param = { md5: md5, distributorId: distributorId, versionCode: versionCode, packageName: packageName, appSize: appSize, appUrl: appUrl, bigIcon: bigIcon, smallIcon: smallIcon, appCategoryId: appCategoryId, desc: desc, installType: installType, appName: appName, appScreenShot: appScreenShot, appVersion: appVersion}

      jsonRqes(url, param, callback, error)
    }
    // 上传应用1
    Vue.prototype.$uploadApp1 = (md5, distributorId, versionCode, packageName, appSize, appUrl, bigIcon, smallIcon, appCategoryId, desc, installType, appName, appScreenShot, appVersion, callback, error) => {
      var path = '/app/add.do'
      var url = appUrlPre + path
      var param = {md5: md5, distributorId: distributorId, versionCode: versionCode, packageName: packageName, appSize: appSize, appUrl: appUrl, bigIcon: bigIcon, smallIcon: smallIcon, appCategoryId: appCategoryId, desc: desc, installType: installType, appName: appName, appScreenShot: appScreenShot, appVersion: appVersion}

      jsonRqes(url, param, callback, error)
    }
    // 更新应用
    Vue.prototype.$updateApp = (md5, appSize, packageName, versionCode, smallIcon, bigIcon, appScreenShot, updateDesc, appId, appUrl, appVersion, isUpdate, distributorId, appName, appType, appDesc, callback, error) => {
      var path = '/appDistribute/updateApp.do'
      var url = addrPre + path
      var param = {md5: md5, appSize: appSize, packageName: packageName, distributorId: distributorId, appName: appName, appType: appType, appDesc: appDesc, versionCode: versionCode, smallIcon: smallIcon, bigIcon: bigIcon, appScreenShot: appScreenShot, updateDesc: updateDesc, appId: appId, appUrl: appUrl, appVersion: appVersion, isUpdate: isUpdate}

      jsonRqes(url, param, callback, error)
    }
    // 更新应用1
    Vue.prototype.$updateApp1 = (md5, appSize, packageName, versionCode, smallIcon, bigIcon, appScreenShot, updateDesc, appId, appUrl, appVersion, isUpdate, distributorId, appName, appType, appDesc, callback, error) => {
      var path = '/appDistribute/updateApp.do'
      var url = appUrlPre + path
      var param = {md5:md5, appSize: appSize, packageName: packageName, distributorId: distributorId, appName: appName, appType: appType, appDesc: appDesc, versionCode: versionCode, smallIcon: smallIcon, bigIcon: bigIcon, appScreenShot: appScreenShot, updateDesc: updateDesc, appId: appId, appUrl: appUrl, appVersion: appVersion, isUpdate: isUpdate}

      jsonRqes(url, param, callback, error)
    }
    // 编辑应用
    Vue.prototype.$editApp = ( md5, appSize, packageName, versionCode, id, appUrl, bigIcon, smallIcon, appCategoryId, desc, installType, appName, appScreenShot, appVersion, callback, error) => {
      var path = '/app/edit.do'
      var url = addrPre + path
      var param = { md5: md5, appSize: appSize, packageName: packageName, versionCode: versionCode, id: id, appUrl: appUrl, bigIcon: bigIcon, smallIcon: smallIcon, appCategoryId: appCategoryId, desc: desc, installType: installType, appName: appName, appScreenShot: appScreenShot, appVersion: appVersion}

      jsonRqes(url, param, callback, error)
    }
    // 编辑应用1
    Vue.prototype.$editApp1 = ( md5, distributorId, appSize, packageName, versionCode, applicationId, appUrl, bigIcon, smallIcon, appCategoryId, desc, installType, appName, appScreenShot, appVersion, callback, error) => {
      var path = '/app/edit.do'
      var url = appUrlPre + path
      var param = { md5: md5, distributorId: distributorId, applicationId: applicationId, appSize: appSize, packageName: packageName, versionCode: versionCode, applicationId: applicationId, appUrl: appUrl, bigIcon: bigIcon, smallIcon: smallIcon, appCategoryId: appCategoryId, desc: desc, installType: installType, appName: appName, appScreenShot: appScreenShot, appVersion: appVersion}

      jsonRqes(url, param, callback, error)
    }
    // 应用历史
    Vue.prototype.$getAppHistory = (appName, packageName, callback, error) => {
      var path = '/app/historyList.do'
      var url = addrPre + path
      var param = {appName: appName, packageName: packageName}

      jsonRqes(url, param, callback, error)
    }
    // 应用历史1
    Vue.prototype.$getAppHistory1 = (distributorId, packageName, callback, error) => {
      var path = '/app/historyList.do'
      var url = appUrlPre + path
      var param = {distributorId: distributorId, packageName: packageName}

      jsonRqes(url, param, callback, error)
    }
    // 删除应用
    Vue.prototype.$deleteApp = (ids, callback, error) => {
      var path = '/app/delete.do'
      var url = addrPre + path
      var param = {ids: ids}
      jsonRqes(url, param, callback, error)
    }
    // 删除应用1
    Vue.prototype.$deleteApp1 = (appid, callback, error) => {
      var path = '/app/delete.do'
      var url = appUrlPre + path
      var param = {appid: appid}
      jsonRqes(url, param, callback, error)
    }
    // 删除应用历史
    Vue.prototype.$deleteAppHis = (applicationId, callback, error) => {
      var path = '/app/deleteVersion.do'
      var url = appUrlPre + path
      var param = {applicationId: applicationId}
      jsonRqes(url, param, callback, error)
    }
    // 提交应用审核
    Vue.prototype.$submitVerifyApp = (id, callback, error) => {
      var path = '/app/submitCheck.do'
      var url = addrPre + path
      var param = {id: id}
      jsonRqes(url, param, callback, error)
    }
    // 提交应用审核1
    Vue.prototype.$submitVerifyApp1 = (id, callback, error) => {
      var path = '/app/submitCheck.do'
      var url = appUrlPre + path
      var param = {id: id}
      jsonRqes(url, param, callback, error)
    }
    // 应用审核
    Vue.prototype.$verifyApp = (token, appid, status, refuseReason, callback, error) => {
      var path = '/app/check.do'
      var url = addrPre + path
      var param = {token: token, appid: appid, status: status, refuseReason: refuseReason}

      jsonRqes(url, param, callback, error)
    }
    // 应用审核1
    Vue.prototype.$verifyApp1 = (distributorId, token, appid, status, refuseReason, callback, error) => {
      var path = '/app/check.do'
      var url = appUrlPre + path
      var param = {distributorId: distributorId, token: token, appid: appid, status: status, refuseReason: refuseReason}
      console.log(url, param)
      jsonRqes(url, param, callback, error)
    }
    // 应用审核推送
    Vue.prototype.$verifyAppPush = (distributorId, terminalNo, appId, callback, error) => {
      var path = '/appDistribute/checkbind.do'
      var url = appUrlPre + path
      var param = {distributorId: distributorId, appId: appId, terminalNo: terminalNo}
      jsonRqes(url, param, callback, error)
    }
    // 获取用户信息
    Vue.prototype.$getUsr = (page, rows, nickName, phone, status, userId, roleId, orderName, orderType, callback, error) => {
      var path = '/user/sub_account.do'
      var url = addrPre + path
      var param = {orderName: orderName, orderType: orderType, page: page, rows: rows, nickName: nickName, phone: phone, status: status, userId: userId, roleId: roleId}

      jsonRqes(url, param, callback, error)
    }
    // 是否已创建证书
    Vue.prototype.$isCer = (distributorId,callback, error) => {
      var path = '/app/isCertificate.do'
      var url = appUrlPre + path
      var param = {distributorId: distributorId}

      jsonRqes(url, param, callback, error)
    }
    // 激活列表
    Vue.prototype.$activeList = (page, rows, token, terminalNo, activationStatus, merchantId, callback, error) => {
      var path = '/authorization/list.do'
      var url = addrPre + path
      var param = {page: page, rows: rows, token: token, terminalNo: terminalNo, activationStatus: activationStatus, merchantId: merchantId}

      jsonRqes(url, param, callback, error)
    }
    // 查操作历史
    Vue.prototype.$cerRightHistory = (page, rows, token, opflag, callback, error) => {
      var path = '/authorization/opRecording.do'
      var url = addrPre + path
      var param = {page: page, rows: rows, token: token, opflag: opflag}

      jsonRqes(url, param, callback, error)
    }
    // 证书授权操作
    Vue.prototype.$cerRightHisOperate = (id, certificateId, merchantId, operationType, pushType, callback, error) => {
      var path = '/authorization/opAgain.do'
      var url = addrPre + path
      var param = {id, certificateId: certificateId, merchantId: merchantId, operationType: operationType, pushType: pushType}
      jsonRqes(url, param, callback, error)
    }

    // 授权指令操作
    Vue.prototype.$cmOperate = (zl, type, terminalNo, pushType, callback, error) => {
      var path = '/cmd/doCommand.do'
      var url = addrPre + path
      var param = {zl: zl, type: type, terminalNo: terminalNo, pushType: pushType}
      jsonRqes(url, param, callback, error)
    }

    // 角色管理列表
    Vue.prototype.$roleMgList = (roleId, callback, error) => {
      var path = '/role/getSubRoles.do'
      var url = addrPre + path
      var param = {roleId: roleId}
      jsonRqes(url, param, callback, error)
    }

    // 编辑角色管理列表
    Vue.prototype.$editRoleMgList = (roleId, subRoleIds, callback, error) => {
      var path = '/role/addSubRoles.do'
      var url = addrPre + path
      var param = {roleId: roleId, subRoleIds: subRoleIds}
      jsonRqes(url, param, callback, error)
    }

    // 编辑logo
    Vue.prototype.$editLogo = (id, logo_address, callback, error) => {
      var path = '/mechanism/updateLogoAddress.do'
      var url = addrPre + path
      var param = {id: id, logo_address: logo_address}
      jsonRqes(url, param, callback, error)
    }

    // 系统版本号
    Vue.prototype.$getVer = (callback, error) => {
      var path = '/versionManage/getVersion.do'
      var url = addrPre + path
      var param = {}
      jsonRqes(url, param, callback, error)
    }
    // mac地址
    Vue.prototype.$fetchMacAddress = (callback, error) => {
      var path = '/versionManage/fetchMacAddress.do'
      var url = addrPre + path
      var param = {}
      jsonRqes(url, param, callback, error)
    }
    // 激活tms
    Vue.prototype.$activationLicense = (license,callback, error) => {
      var path = '/versionManage/activationLicense.do'
      var url = addrPre + path
      var param = {license:license}
      jsonRqes(url, param, callback, error)
    }
    

    // mao: 2017年11月9日
    // 批量(及单个)推送通用方法
    Vue.prototype.$pushGlobalAction = (param, callback, error) => {
      var path = '/push_manage/push.do'
      var url = addrPre + path
      jsonRqes(url, param, callback, error)
    }

    Vue.prototype.$confirmToPushAction = (param, callback, error) => {
      var path = '/push_manage/confirm_push.do'
      var url = addrPre + path
      jsonRqes(url, param, callback, error)
    }

    // jsonp
    var jsonRqes = function (url, param, callback, error) {
      var jsonType = 'application/json;charset=UTF-8'
      var formType = 'application/x-www-form-urlencoded'
      var cType = jsonType
      var is7878 = url.indexOf(':7878') > 0
      param.language = localStorage.system_lang
      param.token = localStorage.user ? localStorage.user : ''
      cType = is7878 ? formType : jsonType
      Vue.http.headers.post = {'Content-Type': cType}
      Vue.http.post(url, param, {emulateJSON: false}).then((res) => {
        var code = res.body.status
        if (code === 600) {
          location.hash = "#/login"
        }
        // console.log(res.body)
        if (callback) {
          callback(res.body)
        }
      }).catch((res) => {
        // console.log('eeeerro', res)
        if (error) {
          error()
        }
        console.log(res)
        var isBan = 0
        // 禁止下载时的提示失败
        var ar = url.split('tms-server-web/')
        if (ar.length > 1) {
          if (ar[1] === 'terminalManagement/getProgress.do') {
            isBan = 1
          }
        }
        if (!isBan) {
          /* Vue.prototype.$showConfirm('', 'Request Error', 'Reset', 'Cancel', 'warning', () => {
            jsonRqes(url, param, callback)
          }, () => {
            // 取消
          }) */
        }

      })
    }
    // b
    var getRqs = function (url, param, callback, error) {
      param.token = localStorage.user ? localStorage.user : ''
      // axios.defaults.withCredentials=true
      axios.get(url, {headers: {}, params: param}).then(res=>{
        if (callback) {
          callback(res.data)
        }
      }).then(res => {
        if (error) {
          error(res)
        }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/wRequester.js